import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Locale: any;
  Long: any;
  ObjectScalar: any;
  UNREPRESENTABLE: any;
};

export type App = Node & {
  __typename?: 'App';
  apiContactEmail?: Maybe<Scalars['String']>;
  apiCredentials?: Maybe<AppApiCredentials>;
  appReviewInstructions?: Maybe<Scalars['String']>;
  appUrl?: Maybe<Scalars['String']>;
  chargeType?: Maybe<AppChargeType>;
  creationDate: Scalars['String'];
  customInstallation?: Maybe<AppInstallation>;
  freeTrialDays: Scalars['Int'];
  id: Scalars['ID'];
  installationCountries?: Maybe<Array<Maybe<Scalars['String']>>>;
  linkedVendor?: Maybe<AppVendorType>;
  listings?: Maybe<Array<Maybe<AppListing>>>;
  name: Scalars['String'];
  numberOfInstallations: Scalars['Int'];
  oneTimeChargeAmount?: Maybe<Scalars['Float']>;
  organization?: Maybe<AppOrganization>;
  pricePlans?: Maybe<Array<Maybe<AppPricePlan>>>;
  redirectUrlWhitelist?: Maybe<Scalars['String']>;
  status: AppStatus;
  testInstallation?: Maybe<AppInstallation>;
  type: AppVisibilityType;
  webhookSubscriptions?: Maybe<Array<Maybe<AppWebhookSubscription>>>;
};

export type AppApiCredentials = {
  __typename?: 'AppApiCredentials';
  apiKey?: Maybe<Scalars['String']>;
  secretKey?: Maybe<Scalars['String']>;
};

export const AppChargeType = {
  FreeToInstall: 'FREE_TO_INSTALL',
  OneTime: 'ONE_TIME',
  Recurring: 'RECURRING'
} as const;

export type AppChargeType = typeof AppChargeType[keyof typeof AppChargeType];
export type AppConnection = {
  __typename?: 'AppConnection';
  edges?: Maybe<Array<Maybe<AppEdge>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Long'];
};

export type AppCreateInput = {
  apiContactEmail: Scalars['String'];
  appReviewInstructions?: Maybe<Scalars['String']>;
  appUrl?: Maybe<Scalars['String']>;
  chargeType: AppChargeType;
  freeTrialDays?: Maybe<Scalars['Int']>;
  installationCountries?: Maybe<Array<Maybe<Scalars['String']>>>;
  name: Scalars['String'];
  oneTimeChargeAmount?: Maybe<Scalars['Float']>;
  redirectUrlWhitelist?: Maybe<Scalars['String']>;
  type: AppVisibilityType;
};

export type AppDashboard = {
  __typename?: 'AppDashboard';
  installations: Array<Maybe<AppDashboardNamedDataType>>;
  installationsByCountry: Array<Maybe<AppDashboardNamedDataType>>;
  uninstallations: Array<Maybe<AppDashboardNamedDataType>>;
};

export type AppDashboardNamedDataType = {
  __typename?: 'AppDashboardNamedDataType';
  amount: Scalars['Float'];
  label: Scalars['String'];
};

export const AppDashboardSplitType = {
  Daily: 'DAILY',
  Monthly: 'MONTHLY',
  Weekly: 'WEEKLY'
} as const;

export type AppDashboardSplitType = typeof AppDashboardSplitType[keyof typeof AppDashboardSplitType];
export type AppEdge = {
  __typename?: 'AppEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<App>;
};

export type AppFileInputInput = {
  fileName?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  size: Scalars['Long'];
  sourceUrl?: Maybe<Scalars['String']>;
  temp?: Maybe<Scalars['Boolean']>;
};

export type AppImage = {
  __typename?: 'AppImage';
  fileName?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
  height: Scalars['Int'];
  s3Key?: Maybe<Scalars['String']>;
  size: Scalars['Long'];
  sourceUrl?: Maybe<Scalars['String']>;
  temp: Scalars['Boolean'];
  width: Scalars['Int'];
};

export type AppImageUpdateInput = {
  fileName?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
  height: Scalars['Int'];
  s3Key?: Maybe<Scalars['String']>;
  size: Scalars['Long'];
  sourceUrl?: Maybe<Scalars['String']>;
  temp?: Maybe<Scalars['Boolean']>;
  width: Scalars['Int'];
};

export type AppInstallation = Node & {
  __typename?: 'AppInstallation';
  creationDate: Scalars['String'];
  id: Scalars['ID'];
  listing: PublicAppListing;
  oldRestApiCredentials?: Maybe<OldRestApiCrendentials>;
  vendor: AppVendorType;
};

export type AppInstallationConnection = {
  __typename?: 'AppInstallationConnection';
  edges?: Maybe<Array<Maybe<AppInstallationEdge>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Long'];
};

export type AppInstallationEdge = {
  __typename?: 'AppInstallationEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AppInstallation>;
};

export type AppKeyBenefitType = {
  __typename?: 'AppKeyBenefitType';
  description?: Maybe<Scalars['String']>;
  image?: Maybe<AppImage>;
  title?: Maybe<Scalars['String']>;
};

export type AppKeyBenefitUpdateInput = {
  description: Scalars['String'];
  image?: Maybe<AppImageUpdateInput>;
  title: Scalars['String'];
};

export type AppListing = Node & {
  __typename?: 'AppListing';
  creationDate: Scalars['String'];
  description: Scalars['String'];
  icon?: Maybe<AppImage>;
  id: Scalars['ID'];
  includeKeyBenefitsImages: Scalars['Boolean'];
  integrations?: Maybe<Array<Maybe<Scalars['String']>>>;
  keyBenefits?: Maybe<Array<Maybe<AppKeyBenefitType>>>;
  language: Scalars['Locale'];
  name: Scalars['String'];
  offerDemoRequest: Scalars['Boolean'];
  pricePlans?: Maybe<Array<Maybe<AppPricePlanDetailsType>>>;
  privacyPolicyUrl?: Maybe<Scalars['String']>;
  promoVideoUrl?: Maybe<Scalars['String']>;
  screenShots?: Maybe<Array<Maybe<AppScreenShotType>>>;
  searchTerms?: Maybe<Array<Maybe<Scalars['String']>>>;
  showContactDetails: Scalars['Boolean'];
  supportEmail?: Maybe<Scalars['String']>;
  supportPhone?: Maybe<Scalars['String']>;
  tagLine: Scalars['String'];
  termsOfServiceUrl?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
};

export type AppListingConnection = {
  __typename?: 'AppListingConnection';
  edges?: Maybe<Array<Maybe<AppListingEdge>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Long'];
};

export type AppListingCreateInput = {
  description: Scalars['String'];
  icon?: Maybe<AppImageUpdateInput>;
  includeKeyBenefitsImages: Scalars['Boolean'];
  integrations?: Maybe<Array<Maybe<Scalars['String']>>>;
  keyBenefits?: Maybe<Array<Maybe<AppKeyBenefitUpdateInput>>>;
  name: Scalars['String'];
  offerDemoRequest: Scalars['Boolean'];
  pricePlans?: Maybe<Array<Maybe<AppPricePlanDetailsUpdateInput>>>;
  privacyPolicyUrl?: Maybe<Scalars['String']>;
  promoVideoUrl?: Maybe<Scalars['String']>;
  screenShots?: Maybe<Array<Maybe<AppScreenShotUpdateInput>>>;
  searchTerms?: Maybe<Array<Maybe<Scalars['String']>>>;
  showContactDetails: Scalars['Boolean'];
  supportEmail: Scalars['String'];
  supportPhone?: Maybe<Scalars['String']>;
  tagLine: Scalars['String'];
  termsOfServiceUrl?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
};

export type AppListingEdge = {
  __typename?: 'AppListingEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AppListing>;
};

export type AppListingFilterInput = {
  category?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  searchTerm?: Maybe<Scalars['String']>;
};

export const AppListingImageType = {
  Icon: 'ICON',
  KeyBenefit: 'KEY_BENEFIT',
  Screenshot: 'SCREENSHOT'
} as const;

export type AppListingImageType = typeof AppListingImageType[keyof typeof AppListingImageType];
export const AppListingScreenshotType = {
  Desktop: 'DESKTOP',
  Mobile: 'MOBILE'
} as const;

export type AppListingScreenshotType = typeof AppListingScreenshotType[keyof typeof AppListingScreenshotType];
export type AppListingSortInput = {
  descending?: Maybe<Scalars['Boolean']>;
  orderBy?: Maybe<AppListingSortOptions>;
};

export const AppListingSortOptions = {
  Name: 'NAME'
} as const;

export type AppListingSortOptions = typeof AppListingSortOptions[keyof typeof AppListingSortOptions];
export type AppListingUpdateInput = {
  description: Scalars['String'];
  icon?: Maybe<AppImageUpdateInput>;
  includeKeyBenefitsImages: Scalars['Boolean'];
  integrations?: Maybe<Array<Maybe<Scalars['String']>>>;
  keyBenefits?: Maybe<Array<Maybe<AppKeyBenefitUpdateInput>>>;
  name: Scalars['String'];
  offerDemoRequest: Scalars['Boolean'];
  pricePlans?: Maybe<Array<Maybe<AppPricePlanDetailsUpdateInput>>>;
  privacyPolicyUrl?: Maybe<Scalars['String']>;
  promoVideoUrl?: Maybe<Scalars['String']>;
  screenShots?: Maybe<Array<Maybe<AppScreenShotUpdateInput>>>;
  searchTerms?: Maybe<Array<Maybe<Scalars['String']>>>;
  showContactDetails: Scalars['Boolean'];
  supportEmail: Scalars['String'];
  supportPhone?: Maybe<Scalars['String']>;
  tagLine: Scalars['String'];
  termsOfServiceUrl?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
};

export type AppListingValidationReportType = {
  __typename?: 'AppListingValidationReportType';
  items?: Maybe<Array<Maybe<AppValidationItemType>>>;
  language?: Maybe<Scalars['Locale']>;
  listingId?: Maybe<Scalars['ID']>;
  valid: Scalars['Boolean'];
};

export type AppMutationResponse = {
  __typename?: 'AppMutationResponse';
  node?: Maybe<App>;
  successful: Scalars['Boolean'];
};

export type AppOrgStatus = {
  __typename?: 'AppOrgStatus';
  amount?: Maybe<Scalars['Long']>;
  displayAmount?: Maybe<Scalars['String']>;
  hasRejectedPayout?: Maybe<Scalars['Boolean']>;
  hasUnclaimedPayout?: Maybe<Scalars['Boolean']>;
  hasValidPayoutSettings?: Maybe<Scalars['Boolean']>;
  hasValidTaxForm?: Maybe<Scalars['Boolean']>;
  payoutSettingsPreview?: Maybe<Scalars['String']>;
  periodFrom?: Maybe<Scalars['String']>;
  periodTo?: Maybe<Scalars['String']>;
};

export type AppOrganization = Node & {
  __typename?: 'AppOrganization';
  businessEmail?: Maybe<Scalars['String']>;
  businessName?: Maybe<Scalars['String']>;
  emergencyDeveloperEmail?: Maybe<Scalars['String']>;
  emergencyDeveloperPhoneNumber?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  organizationId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  supportEmail?: Maybe<Scalars['String']>;
  termsApiAgreed: Scalars['Boolean'];
  termsPartnerAgreed: Scalars['Boolean'];
  websiteUrl?: Maybe<Scalars['String']>;
};

export type AppOrganizationMutationResponse = {
  __typename?: 'AppOrganizationMutationResponse';
  node?: Maybe<AppOrganization>;
  successful: Scalars['Boolean'];
};

export const AppOrganizationPayoutPaymentType = {
  Ach: 'ACH',
  Achgiro: 'ACHGIRO',
  Sepa: 'SEPA',
  Wire: 'WIRE'
} as const;

export type AppOrganizationPayoutPaymentType = typeof AppOrganizationPayoutPaymentType[keyof typeof AppOrganizationPayoutPaymentType];
export type AppOrganizationUpdateInput = {
  businessEmail?: Maybe<Scalars['String']>;
  businessName: Scalars['String'];
  emergencyDeveloperEmail?: Maybe<Scalars['String']>;
  emergencyDeveloperPhoneNumber?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  supportEmail?: Maybe<Scalars['String']>;
  termsApiAgreed: Scalars['Boolean'];
  termsPartnerAgreed: Scalars['Boolean'];
  websiteUrl?: Maybe<Scalars['String']>;
};

export type AppPricePlan = Node & {
  __typename?: 'AppPricePlan';
  appId: Scalars['ID'];
  bookingFeePercentage?: Maybe<Scalars['Float']>;
  creationDate: Scalars['String'];
  discountedYearlyPrice: Scalars['Boolean'];
  id: Scalars['ID'];
  monthlyAmount?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  oneTimeAmount?: Maybe<Scalars['Float']>;
  type?: Maybe<AppPricePlanEnumType>;
  yearlyAmount?: Maybe<Scalars['Float']>;
};

export type AppPricePlanCreateInput = {
  discountedYearlyPrice: Scalars['Boolean'];
  monthlyAmount?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  oneTimeAmount?: Maybe<Scalars['Float']>;
  type: AppPricePlanEnumType;
  yearlyAmount?: Maybe<Scalars['Float']>;
};

export type AppPricePlanDetailsType = {
  __typename?: 'AppPricePlanDetailsType';
  features?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  plan?: Maybe<AppPricePlan>;
  planId?: Maybe<Scalars['String']>;
};

export type AppPricePlanDetailsUpdateInput = {
  features: Scalars['String'];
  name: Scalars['String'];
  planId: Scalars['ID'];
};

export const AppPricePlanEnumType = {
  Free: 'FREE',
  MonthlyCharge: 'MONTHLY_CHARGE',
  OneTimeCharge: 'ONE_TIME_CHARGE',
  YearlyCharge: 'YEARLY_CHARGE'
} as const;

export type AppPricePlanEnumType = typeof AppPricePlanEnumType[keyof typeof AppPricePlanEnumType];
export type AppPricePlanMutationResponse = {
  __typename?: 'AppPricePlanMutationResponse';
  node?: Maybe<AppPricePlan>;
  successful: Scalars['Boolean'];
};

export type AppPricePlanUpdateInput = {
  discountedYearlyPrice: Scalars['Boolean'];
  monthlyAmount?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  oneTimeAmount?: Maybe<Scalars['Float']>;
  type: AppPricePlanEnumType;
  yearlyAmount?: Maybe<Scalars['Float']>;
};

export type AppScreenShotType = {
  __typename?: 'AppScreenShotType';
  description?: Maybe<Scalars['String']>;
  image?: Maybe<AppImage>;
  type?: Maybe<AppListingScreenshotType>;
};

export type AppScreenShotUpdateInput = {
  description: Scalars['String'];
  image: AppImageUpdateInput;
  type: AppListingScreenshotType;
};

export const AppStatus = {
  Draft: 'DRAFT',
  InReview: 'IN_REVIEW',
  Published: 'PUBLISHED',
  Rejected: 'REJECTED',
  Unpublished: 'UNPUBLISHED'
} as const;

export type AppStatus = typeof AppStatus[keyof typeof AppStatus];
export type AppStorePayoutInvoiceType = {
  __typename?: 'AppStorePayoutInvoiceType';
  fileName?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Long']>;
  s3Key?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Long']>;
};

export const AppStorePayoutStatus = {
  InReview: 'IN_REVIEW',
  Paid: 'PAID',
  Rejected: 'REJECTED'
} as const;

export type AppStorePayoutStatus = typeof AppStorePayoutStatus[keyof typeof AppStorePayoutStatus];
export type AppStorePayoutType = Node & {
  __typename?: 'AppStorePayoutType';
  amount?: Maybe<Scalars['String']>;
  creationDate?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoiceDateFrom?: Maybe<Scalars['String']>;
  invoiceDateTo?: Maybe<Scalars['String']>;
  payoutInvoice?: Maybe<AppStorePayoutInvoiceType>;
  pdfInvoiceUrl?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<AppStorePayoutStatus>;
};

export type AppStorePayoutTypeConnection = {
  __typename?: 'AppStorePayoutTypeConnection';
  edges?: Maybe<Array<Maybe<AppStorePayoutTypeEdge>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Long'];
};

export type AppStorePayoutTypeEdge = {
  __typename?: 'AppStorePayoutTypeEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AppStorePayoutType>;
};

export type AppStorePayoutTypeMutationResponse = {
  __typename?: 'AppStorePayoutTypeMutationResponse';
  node?: Maybe<AppStorePayoutType>;
  successful: Scalars['Boolean'];
};

export type AppUpdateInput = {
  apiContactEmail: Scalars['String'];
  appReviewInstructions?: Maybe<Scalars['String']>;
  appUrl?: Maybe<Scalars['String']>;
  chargeType: AppChargeType;
  freeTrialDays?: Maybe<Scalars['Int']>;
  installationCountries?: Maybe<Array<Maybe<Scalars['String']>>>;
  name: Scalars['String'];
  oneTimeChargeAmount?: Maybe<Scalars['Float']>;
  redirectUrlWhitelist?: Maybe<Scalars['String']>;
  type: AppVisibilityType;
};

export type AppUserAccount = Node & {
  __typename?: 'AppUserAccount';
  accountOwner: Scalars['Boolean'];
  adminUser: Scalars['Boolean'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  orgId: Scalars['ID'];
  orgName?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  termsApiAgreed: Scalars['Boolean'];
  termsPartnerAgreed: Scalars['Boolean'];
};

export type AppUserAccountConnection = {
  __typename?: 'AppUserAccountConnection';
  edges?: Maybe<Array<Maybe<AppUserAccountEdge>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Long'];
};

export type AppUserAccountCreateInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
};

export type AppUserAccountEdge = {
  __typename?: 'AppUserAccountEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AppUserAccount>;
};

export type AppUserAccountFilterInput = {
  searchTerm?: Maybe<Scalars['String']>;
};

export type AppUserAccountLoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type AppUserAccountMutationResponse = {
  __typename?: 'AppUserAccountMutationResponse';
  node?: Maybe<AppUserAccount>;
  successful: Scalars['Boolean'];
};

export type AppUserAccountSignupInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  termsApiAgreed: Scalars['Boolean'];
  termsPartnerAgreed: Scalars['Boolean'];
};

export type AppUserAccountSortInput = {
  descending?: Maybe<Scalars['Boolean']>;
  orderBy?: Maybe<AppUserAccountSortOptions>;
};

export const AppUserAccountSortOptions = {
  FirstName: 'FIRST_NAME',
  LastName: 'LAST_NAME'
} as const;

export type AppUserAccountSortOptions = typeof AppUserAccountSortOptions[keyof typeof AppUserAccountSortOptions];
export type AppUserAccountUpdateInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password?: Maybe<Scalars['String']>;
};

export const AppValidationCheckType = {
  Description: 'DESCRIPTION',
  EmergencyContact: 'EMERGENCY_CONTACT',
  Icon: 'ICON',
  InstallationUrls: 'INSTALLATION_URLS',
  KeyBenefits: 'KEY_BENEFITS',
  Listing: 'LISTING',
  RecurringPlans: 'RECURRING_PLANS',
  Rejected: 'REJECTED',
  ReviewInstructions: 'REVIEW_INSTRUCTIONS',
  Screenshots: 'SCREENSHOTS',
  TermsOfServiceUrl: 'TERMS_OF_SERVICE_URL',
  TermAgreement: 'TERM_AGREEMENT',
  TestInstall: 'TEST_INSTALL'
} as const;

export type AppValidationCheckType = typeof AppValidationCheckType[keyof typeof AppValidationCheckType];
export type AppValidationItemType = {
  __typename?: 'AppValidationItemType';
  message?: Maybe<Scalars['String']>;
  type?: Maybe<AppValidationCheckType>;
  valid: Scalars['Boolean'];
};

export type AppValidationReportType = {
  __typename?: 'AppValidationReportType';
  items?: Maybe<Array<Maybe<AppValidationItemType>>>;
  listingsReports?: Maybe<Array<Maybe<AppListingValidationReportType>>>;
  testInstallationSuccessful: Scalars['Boolean'];
  valid: Scalars['Boolean'];
};

export type AppVendorType = Node & {
  __typename?: 'AppVendorType';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type AppVendorTypeConnection = {
  __typename?: 'AppVendorTypeConnection';
  edges?: Maybe<Array<Maybe<AppVendorTypeEdge>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Long'];
};

export type AppVendorTypeEdge = {
  __typename?: 'AppVendorTypeEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AppVendorType>;
};

export const AppVisibilityType = {
  Custom: 'CUSTOM',
  Public: 'PUBLIC'
} as const;

export type AppVisibilityType = typeof AppVisibilityType[keyof typeof AppVisibilityType];
export type AppWebhookSubscription = Node & {
  __typename?: 'AppWebhookSubscription';
  creationDate: Scalars['String'];
  id: Scalars['ID'];
  topic?: Maybe<AppWebhookTopic>;
  url?: Maybe<Scalars['String']>;
};

export type AppWebhookSubscriptionMutationResponse = {
  __typename?: 'AppWebhookSubscriptionMutationResponse';
  node?: Maybe<AppWebhookSubscription>;
  successful: Scalars['Boolean'];
};

export type AppWebhookSubscriptionUpdateInput = {
  topic: AppWebhookTopic;
  url: Scalars['String'];
};

export const AppWebhookTopic = {
  AppUninstall: 'APP_UNINSTALL',
  BookingsCancel: 'BOOKINGS_CANCEL',
  BookingsCreate: 'BOOKINGS_CREATE',
  BookingsPayment: 'BOOKINGS_PAYMENT',
  BookingsRefund: 'BOOKINGS_REFUND',
  BookingsUpdate: 'BOOKINGS_UPDATE',
  ExperiencesAvailabilityUpdate: 'EXPERIENCES_AVAILABILITY_UPDATE',
  ExperiencesCreate: 'EXPERIENCES_CREATE',
  ExperiencesUpdate: 'EXPERIENCES_UPDATE'
} as const;

export type AppWebhookTopic = typeof AppWebhookTopic[keyof typeof AppWebhookTopic];
export type CurrencyType = {
  __typename?: 'CurrencyType';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};



export type Mutation = {
  __typename?: 'Mutation';
  appAccountLogin?: Maybe<AppUserAccountMutationResponse>;
  appAccountLogout: Scalars['Boolean'];
  appAccountSignup?: Maybe<AppUserAccountMutationResponse>;
  appAccountUserChangeOrg?: Maybe<AppUserAccountMutationResponse>;
  appAccountUserCreate?: Maybe<AppUserAccountMutationResponse>;
  appAccountUserDelete?: Maybe<AppUserAccountMutationResponse>;
  appAccountUserUpdate?: Maybe<AppUserAccountMutationResponse>;
  appCreate?: Maybe<AppMutationResponse>;
  appCustomLinkToVendor?: Maybe<AppMutationResponse>;
  appCustomPublish?: Maybe<App>;
  appDelete?: Maybe<AppMutationResponse>;
  appListingCreate?: Maybe<AppMutationResponse>;
  appListingDelete?: Maybe<AppMutationResponse>;
  appListingImageDelete?: Maybe<AppMutationResponse>;
  appListingUpdate?: Maybe<AppMutationResponse>;
  appOrgUpdate?: Maybe<AppOrganizationMutationResponse>;
  appPricePlanCreate?: Maybe<AppMutationResponse>;
  appPricePlanDelete?: Maybe<AppMutationResponse>;
  appPricePlanUpdate?: Maybe<AppPricePlanMutationResponse>;
  appSubmitForReview?: Maybe<AppMutationResponse>;
  appUninstallTest?: Maybe<AppMutationResponse>;
  appUpdate?: Maybe<AppMutationResponse>;
  invoiceFileDelete?: Maybe<ObjectMutationResponse>;
  payoutSettingsUpdate?: Maybe<PayoutSettingsTypeMutationResponse>;
  s3UploadAuthorization?: Maybe<S3UploadRequestMutationResponse>;
  s3UploadPayoutInvoice?: Maybe<S3UploadRequestMutationResponse>;
  submitPayoutRequest?: Maybe<AppStorePayoutTypeMutationResponse>;
  updatePayoutRequest?: Maybe<AppStorePayoutTypeMutationResponse>;
  webhookCreate?: Maybe<AppMutationResponse>;
  webhookDelete?: Maybe<AppMutationResponse>;
  webhookUpdate?: Maybe<AppWebhookSubscriptionMutationResponse>;
};


export type MutationAppAccountLoginArgs = {
  account?: Maybe<AppUserAccountLoginInput>;
};


export type MutationAppAccountSignupArgs = {
  account?: Maybe<AppUserAccountSignupInput>;
};


export type MutationAppAccountUserChangeOrgArgs = {
  id: Scalars['ID'];
};


export type MutationAppAccountUserCreateArgs = {
  userInfo: AppUserAccountCreateInput;
};


export type MutationAppAccountUserDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationAppAccountUserUpdateArgs = {
  id: Scalars['ID'];
  userInfo: AppUserAccountUpdateInput;
};


export type MutationAppCreateArgs = {
  appInfo?: Maybe<AppCreateInput>;
};


export type MutationAppCustomLinkToVendorArgs = {
  appId?: Maybe<Scalars['ID']>;
  vendorId?: Maybe<Scalars['ID']>;
};


export type MutationAppCustomPublishArgs = {
  appId?: Maybe<Scalars['ID']>;
};


export type MutationAppDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationAppListingCreateArgs = {
  id: Scalars['ID'];
  listingInfo?: Maybe<AppListingCreateInput>;
};


export type MutationAppListingDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationAppListingImageDeleteArgs = {
  id: Scalars['ID'];
  imageKey?: Maybe<Scalars['String']>;
  imageType?: Maybe<AppListingImageType>;
};


export type MutationAppListingUpdateArgs = {
  id: Scalars['ID'];
  listingInfo?: Maybe<AppListingUpdateInput>;
};


export type MutationAppOrgUpdateArgs = {
  id: Scalars['ID'];
  orgInfo?: Maybe<AppOrganizationUpdateInput>;
};


export type MutationAppPricePlanCreateArgs = {
  id: Scalars['ID'];
  planInfo?: Maybe<AppPricePlanCreateInput>;
};


export type MutationAppPricePlanDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationAppPricePlanUpdateArgs = {
  id: Scalars['ID'];
  planInfo?: Maybe<AppPricePlanUpdateInput>;
};


export type MutationAppSubmitForReviewArgs = {
  id: Scalars['ID'];
};


export type MutationAppUninstallTestArgs = {
  id: Scalars['ID'];
};


export type MutationAppUpdateArgs = {
  appInfo?: Maybe<AppUpdateInput>;
  id: Scalars['ID'];
};


export type MutationInvoiceFileDeleteArgs = {
  fileKey?: Maybe<Scalars['String']>;
};


export type MutationPayoutSettingsUpdateArgs = {
  payoutSettings: PayoutSettingsInput;
};


export type MutationS3UploadAuthorizationArgs = {
  contentType?: Maybe<Scalars['String']>;
};


export type MutationSubmitPayoutRequestArgs = {
  fileInput?: Maybe<AppFileInputInput>;
};


export type MutationUpdatePayoutRequestArgs = {
  fileInput?: Maybe<AppFileInputInput>;
  id: Scalars['ID'];
};


export type MutationWebhookCreateArgs = {
  id: Scalars['ID'];
  webhookInfo?: Maybe<AppWebhookSubscriptionUpdateInput>;
};


export type MutationWebhookDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationWebhookUpdateArgs = {
  id: Scalars['ID'];
  webhookInfo?: Maybe<AppWebhookSubscriptionUpdateInput>;
};

export type Node = {
  id: Scalars['ID'];
};

export type ObjectMutationResponse = {
  __typename?: 'ObjectMutationResponse';
  node?: Maybe<Scalars['ObjectScalar']>;
  successful: Scalars['Boolean'];
};


export type OldRestApiCrendentials = {
  __typename?: 'OldRestApiCrendentials';
  accessKey?: Maybe<Scalars['String']>;
  secretKey?: Maybe<Scalars['String']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type PayoutNonUsBankInputInput = {
  bankId?: Maybe<Scalars['String']>;
  branchId?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  swift?: Maybe<Scalars['String']>;
};

export type PayoutSettingsInput = {
  bankAccountNumber?: Maybe<Scalars['String']>;
  bankName?: Maybe<Scalars['String']>;
  currencyCode: Scalars['String'];
  isUsResident: Scalars['Boolean'];
  nonUSBankInput?: Maybe<PayoutNonUsBankInputInput>;
  payableTo?: Maybe<Scalars['String']>;
  paymentTerms?: Maybe<Scalars['String']>;
  paymentType?: Maybe<AppOrganizationPayoutPaymentType>;
  payoutContactEmail?: Maybe<Scalars['String']>;
  payoutContactPhoneNumber?: Maybe<Scalars['String']>;
  usBankInput?: Maybe<PayoutUsBankInputInput>;
};

export type PayoutSettingsType = {
  __typename?: 'PayoutSettingsType';
  abaRouting?: Maybe<Scalars['String']>;
  bankAccountNumber?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  bankName?: Maybe<Scalars['String']>;
  branchId?: Maybe<Scalars['String']>;
  currencyCode?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  payableTo?: Maybe<Scalars['String']>;
  paymentTerms?: Maybe<Scalars['String']>;
  paymentType?: Maybe<AppOrganizationPayoutPaymentType>;
  payoutContactEmail?: Maybe<Scalars['String']>;
  payoutContactPhoneNumber?: Maybe<Scalars['String']>;
  swift?: Maybe<Scalars['String']>;
  usResident: Scalars['Boolean'];
};

export type PayoutSettingsTypeMutationResponse = {
  __typename?: 'PayoutSettingsTypeMutationResponse';
  node?: Maybe<PayoutSettingsType>;
  successful: Scalars['Boolean'];
};

export type PayoutUsBankInputInput = {
  abaRouting?: Maybe<Scalars['String']>;
};

export type PublicAppListing = Node & {
  __typename?: 'PublicAppListing';
  appId: Scalars['ID'];
  appUrl?: Maybe<Scalars['String']>;
  chargeType?: Maybe<AppChargeType>;
  commitmentMonths?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  freeTrialDays: Scalars['Int'];
  icon?: Maybe<AppImage>;
  id: Scalars['ID'];
  includeKeyBenefitsImages: Scalars['Boolean'];
  keyBenefits?: Maybe<Array<Maybe<AppKeyBenefitType>>>;
  name: Scalars['String'];
  offerDemoRequest: Scalars['Boolean'];
  oneTimeChargeAmount?: Maybe<Scalars['Float']>;
  organization?: Maybe<PublicAppOrg>;
  pricePlans?: Maybe<Array<Maybe<AppPricePlanDetailsType>>>;
  privacyPolicyUrl?: Maybe<Scalars['String']>;
  promoVideoUrl?: Maybe<Scalars['String']>;
  screenShots?: Maybe<Array<Maybe<AppScreenShotType>>>;
  showContactDetails: Scalars['Boolean'];
  supportEmail?: Maybe<Scalars['String']>;
  supportPhone?: Maybe<Scalars['String']>;
  tagLine: Scalars['String'];
  termsOfServiceUrl?: Maybe<Scalars['String']>;
  vendorFeatureTypes?: Maybe<Array<Maybe<VendorFeatureType>>>;
  websiteUrl?: Maybe<Scalars['String']>;
};

export type PublicAppListingConnection = {
  __typename?: 'PublicAppListingConnection';
  edges?: Maybe<Array<Maybe<PublicAppListingEdge>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Long'];
};

export type PublicAppListingEdge = {
  __typename?: 'PublicAppListingEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<PublicAppListing>;
};

export type PublicAppOrg = Node & {
  __typename?: 'PublicAppOrg';
  businessEmail?: Maybe<Scalars['String']>;
  businessName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  phoneNumber?: Maybe<Scalars['String']>;
  supportEmail?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  AppDashboardQuery?: Maybe<AppDashboard>;
  GetCurrencies?: Maybe<Array<Maybe<CurrencyType>>>;
  GetOrganizations?: Maybe<Array<Maybe<AppOrganization>>>;
  app?: Maybe<App>;
  appAccountLogin?: Maybe<AppUserAccountMutationResponse>;
  appAccountSignup?: Maybe<AppUserAccountMutationResponse>;
  appAccountUser?: Maybe<AppUserAccount>;
  appAccountUserChangeOrg?: Maybe<AppUserAccountMutationResponse>;
  appAccountUserCreate?: Maybe<AppUserAccountMutationResponse>;
  appAccountUserDelete?: Maybe<AppUserAccountMutationResponse>;
  appAccountUserList?: Maybe<AppUserAccountConnection>;
  appAccountUserUpdate?: Maybe<AppUserAccountMutationResponse>;
  appCreate?: Maybe<AppMutationResponse>;
  appCustomLinkToVendor?: Maybe<AppMutationResponse>;
  appCustomPublish?: Maybe<App>;
  appDelete?: Maybe<AppMutationResponse>;
  appListingCreate?: Maybe<AppMutationResponse>;
  appListingDelete?: Maybe<AppMutationResponse>;
  appListingImageDelete?: Maybe<AppMutationResponse>;
  appListingUpdate?: Maybe<AppMutationResponse>;
  appListings?: Maybe<AppListingConnection>;
  appOrg?: Maybe<AppOrganization>;
  appOrgStatus?: Maybe<AppOrgStatus>;
  appOrgUpdate?: Maybe<AppOrganizationMutationResponse>;
  appPricePlanCreate?: Maybe<AppMutationResponse>;
  appPricePlanDelete?: Maybe<AppMutationResponse>;
  appPricePlanUpdate?: Maybe<AppPricePlanMutationResponse>;
  appSubmitForReview?: Maybe<AppMutationResponse>;
  appUninstallTest?: Maybe<AppMutationResponse>;
  appUpdate?: Maybe<AppMutationResponse>;
  appValidationReport?: Maybe<AppValidationReportType>;
  appVendorSearch?: Maybe<AppVendorTypeConnection>;
  apps?: Maybe<AppConnection>;
  getPayoutDetails?: Maybe<AppStorePayoutType>;
  getPayoutSettings?: Maybe<PayoutSettingsType>;
  getPayouts?: Maybe<AppStorePayoutTypeConnection>;
  installation?: Maybe<AppInstallation>;
  installations?: Maybe<AppInstallationConnection>;
  invoiceFileDelete?: Maybe<ObjectMutationResponse>;
  node?: Maybe<Node>;
  payoutSettingsUpdate?: Maybe<PayoutSettingsTypeMutationResponse>;
  publicAppListing?: Maybe<PublicAppListing>;
  publicAppListings?: Maybe<PublicAppListingConnection>;
  s3UploadAuthorization?: Maybe<S3UploadRequestMutationResponse>;
  s3UploadPayoutInvoice?: Maybe<S3UploadRequestMutationResponse>;
  submitPayoutRequest?: Maybe<AppStorePayoutTypeMutationResponse>;
  updatePayoutRequest?: Maybe<AppStorePayoutTypeMutationResponse>;
  webhookCreate?: Maybe<AppMutationResponse>;
  webhookDelete?: Maybe<AppMutationResponse>;
  webhookUpdate?: Maybe<AppWebhookSubscriptionMutationResponse>;
};


export type QueryAppDashboardQueryArgs = {
  split?: Maybe<AppDashboardSplitType>;
  timestampFrom: Scalars['Long'];
  timestampTo: Scalars['Long'];
};


export type QueryAppArgs = {
  id: Scalars['ID'];
};


export type QueryAppAccountLoginArgs = {
  account?: Maybe<AppUserAccountLoginInput>;
};


export type QueryAppAccountSignupArgs = {
  account?: Maybe<AppUserAccountSignupInput>;
};


export type QueryAppAccountUserArgs = {
  id: Scalars['ID'];
};


export type QueryAppAccountUserChangeOrgArgs = {
  id: Scalars['ID'];
};


export type QueryAppAccountUserCreateArgs = {
  userInfo: AppUserAccountCreateInput;
};


export type QueryAppAccountUserDeleteArgs = {
  id: Scalars['ID'];
};


export type QueryAppAccountUserListArgs = {
  after?: Maybe<Scalars['String']>;
  filter?: Maybe<AppUserAccountFilterInput>;
  first: Scalars['Int'];
  sorting?: Maybe<AppUserAccountSortInput>;
};


export type QueryAppAccountUserUpdateArgs = {
  id: Scalars['ID'];
  userInfo: AppUserAccountUpdateInput;
};


export type QueryAppCreateArgs = {
  appInfo?: Maybe<AppCreateInput>;
};


export type QueryAppCustomLinkToVendorArgs = {
  appId?: Maybe<Scalars['ID']>;
  vendorId?: Maybe<Scalars['ID']>;
};


export type QueryAppCustomPublishArgs = {
  appId?: Maybe<Scalars['ID']>;
};


export type QueryAppDeleteArgs = {
  id: Scalars['ID'];
};


export type QueryAppListingCreateArgs = {
  id: Scalars['ID'];
  listingInfo?: Maybe<AppListingCreateInput>;
};


export type QueryAppListingDeleteArgs = {
  id: Scalars['ID'];
};


export type QueryAppListingImageDeleteArgs = {
  id: Scalars['ID'];
  imageKey?: Maybe<Scalars['String']>;
  imageType?: Maybe<AppListingImageType>;
};


export type QueryAppListingUpdateArgs = {
  id: Scalars['ID'];
  listingInfo?: Maybe<AppListingUpdateInput>;
};


export type QueryAppListingsArgs = {
  after?: Maybe<Scalars['String']>;
  first: Scalars['Int'];
  id: Scalars['ID'];
};


export type QueryAppOrgArgs = {
  id: Scalars['ID'];
};


export type QueryAppOrgUpdateArgs = {
  id: Scalars['ID'];
  orgInfo?: Maybe<AppOrganizationUpdateInput>;
};


export type QueryAppPricePlanCreateArgs = {
  id: Scalars['ID'];
  planInfo?: Maybe<AppPricePlanCreateInput>;
};


export type QueryAppPricePlanDeleteArgs = {
  id: Scalars['ID'];
};


export type QueryAppPricePlanUpdateArgs = {
  id: Scalars['ID'];
  planInfo?: Maybe<AppPricePlanUpdateInput>;
};


export type QueryAppSubmitForReviewArgs = {
  id: Scalars['ID'];
};


export type QueryAppUninstallTestArgs = {
  id: Scalars['ID'];
};


export type QueryAppUpdateArgs = {
  appInfo?: Maybe<AppUpdateInput>;
  id: Scalars['ID'];
};


export type QueryAppValidationReportArgs = {
  id: Scalars['ID'];
};


export type QueryAppVendorSearchArgs = {
  after?: Maybe<Scalars['String']>;
  first: Scalars['Int'];
  query?: Maybe<Scalars['String']>;
};


export type QueryAppsArgs = {
  after?: Maybe<Scalars['String']>;
  first: Scalars['Int'];
};


export type QueryGetPayoutDetailsArgs = {
  id: Scalars['ID'];
};


export type QueryGetPayoutsArgs = {
  after?: Maybe<Scalars['String']>;
  first: Scalars['Int'];
};


export type QueryInstallationArgs = {
  id: Scalars['ID'];
};


export type QueryInstallationsArgs = {
  after?: Maybe<Scalars['String']>;
  first: Scalars['Int'];
  id: Scalars['ID'];
};


export type QueryInvoiceFileDeleteArgs = {
  fileKey?: Maybe<Scalars['String']>;
};


export type QueryNodeArgs = {
  id: Scalars['ID'];
};


export type QueryPayoutSettingsUpdateArgs = {
  payoutSettings: PayoutSettingsInput;
};


export type QueryPublicAppListingArgs = {
  id: Scalars['ID'];
};


export type QueryPublicAppListingsArgs = {
  after?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  filter?: Maybe<AppListingFilterInput>;
  first: Scalars['Int'];
  sorting?: Maybe<AppListingSortInput>;
};


export type QueryS3UploadAuthorizationArgs = {
  contentType?: Maybe<Scalars['String']>;
};


export type QuerySubmitPayoutRequestArgs = {
  fileInput?: Maybe<AppFileInputInput>;
};


export type QueryUpdatePayoutRequestArgs = {
  fileInput?: Maybe<AppFileInputInput>;
  id: Scalars['ID'];
};


export type QueryWebhookCreateArgs = {
  id: Scalars['ID'];
  webhookInfo?: Maybe<AppWebhookSubscriptionUpdateInput>;
};


export type QueryWebhookDeleteArgs = {
  id: Scalars['ID'];
};


export type QueryWebhookUpdateArgs = {
  id: Scalars['ID'];
  webhookInfo?: Maybe<AppWebhookSubscriptionUpdateInput>;
};

export type S3Meta = {
  __typename?: 'S3Meta';
  id?: Maybe<Scalars['String']>;
};

export type S3UploadRequest = {
  __typename?: 'S3UploadRequest';
  meta?: Maybe<S3Meta>;
  uploadUrl?: Maybe<Scalars['String']>;
};

export type S3UploadRequestMutationResponse = {
  __typename?: 'S3UploadRequestMutationResponse';
  node?: Maybe<S3UploadRequest>;
  successful: Scalars['Boolean'];
};


export const VendorFeatureType = {
  Accommodations: 'ACCOMMODATIONS',
  Activities: 'ACTIVITIES',
  AdvancedWebsites: 'ADVANCED_WEBSITES',
  Agents: 'AGENTS',
  CarRentals: 'CAR_RENTALS',
  Crm: 'CRM',
  CustomReports: 'CUSTOM_REPORTS',
  GiftCards: 'GIFT_CARDS',
  GoogleTtd: 'GOOGLE_TTD',
  InventoryApi: 'INVENTORY_API',
  Marketplace: 'MARKETPLACE',
  OperatorApp: 'OPERATOR_APP',
  Otas: 'OTAS',
  OwnBookingChannel: 'OWN_BOOKING_CHANNEL',
  SellForOthers: 'SELL_FOR_OTHERS',
  SubVendors: 'SUB_VENDORS',
  SupplyForOthers: 'SUPPLY_FOR_OTHERS',
  Transports: 'TRANSPORTS',
  UnlimitedUsers: 'UNLIMITED_USERS',
  UseAffiliates: 'USE_AFFILIATES',
  UseMyallocator: 'USE_MYALLOCATOR',
  UseTranslations: 'USE_TRANSLATIONS',
  Websites: 'WEBSITES',
  WebServices: 'WEB_SERVICES',
  Widgets: 'WIDGETS',
  WidgetUpsell: 'WIDGET_UPSELL'
} as const;

export type VendorFeatureType = typeof VendorFeatureType[keyof typeof VendorFeatureType];
export type AppListingFragmentCommon = (
  { __typename?: 'AppListing' }
  & Pick<AppListing, 'id' | 'creationDate' | 'language' | 'name' | 'tagLine' | 'description' | 'searchTerms' | 'integrations' | 'promoVideoUrl' | 'includeKeyBenefitsImages' | 'supportEmail' | 'supportPhone' | 'websiteUrl' | 'privacyPolicyUrl' | 'termsOfServiceUrl'>
  & { icon?: Maybe<(
    { __typename?: 'AppImage' }
    & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl'>
  )>, screenShots?: Maybe<Array<Maybe<(
    { __typename?: 'AppScreenShotType' }
    & Pick<AppScreenShotType, 'type' | 'description'>
    & { image?: Maybe<(
      { __typename?: 'AppImage' }
      & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl'>
    )> }
  )>>>, keyBenefits?: Maybe<Array<Maybe<(
    { __typename?: 'AppKeyBenefitType' }
    & Pick<AppKeyBenefitType, 'title' | 'description'>
    & { image?: Maybe<(
      { __typename?: 'AppImage' }
      & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl'>
    )> }
  )>>>, pricePlans?: Maybe<Array<Maybe<(
    { __typename?: 'AppPricePlanDetailsType' }
    & Pick<AppPricePlanDetailsType, 'planId' | 'name' | 'features'>
  )>>> }
);

export type AppFragmentCommon = (
  { __typename?: 'App' }
  & Pick<App, 'id' | 'name' | 'creationDate' | 'status' | 'type' | 'apiContactEmail' | 'numberOfInstallations' | 'appUrl' | 'redirectUrlWhitelist' | 'chargeType' | 'installationCountries' | 'oneTimeChargeAmount' | 'freeTrialDays' | 'appReviewInstructions'>
  & { apiCredentials?: Maybe<(
    { __typename?: 'AppApiCredentials' }
    & Pick<AppApiCredentials, 'apiKey' | 'secretKey'>
  )>, linkedVendor?: Maybe<(
    { __typename?: 'AppVendorType' }
    & Pick<AppVendorType, 'id' | 'name'>
  )>, pricePlans?: Maybe<Array<Maybe<(
    { __typename?: 'AppPricePlan' }
    & Pick<AppPricePlan, 'id' | 'creationDate' | 'name' | 'type' | 'discountedYearlyPrice' | 'monthlyAmount' | 'yearlyAmount'>
  )>>>, listings?: Maybe<Array<Maybe<(
    { __typename?: 'AppListing' }
    & Pick<AppListing, 'id'>
    & AppListingFragment
  )>>> }
);

export type PayoutSettingsCommon = (
  { __typename?: 'PayoutSettingsType' }
  & Pick<PayoutSettingsType, 'abaRouting' | 'bankAccountNumber' | 'bankId' | 'bankName' | 'branchId' | 'currencyCode' | 'iban' | 'payableTo' | 'paymentTerms' | 'paymentType' | 'payoutContactEmail' | 'payoutContactPhoneNumber' | 'swift' | 'usResident'>
);

export type S3UploadMutationVariables = Exact<{
  contentType?: Maybe<Scalars['String']>;
}>;


export type S3UploadMutation = (
  { __typename?: 'Mutation' }
  & { s3UploadAuthorization?: Maybe<(
    { __typename?: 'S3UploadRequestMutationResponse' }
    & { node?: Maybe<(
      { __typename?: 'S3UploadRequest' }
      & Pick<S3UploadRequest, 'uploadUrl'>
      & { meta?: Maybe<(
        { __typename?: 'S3Meta' }
        & Pick<S3Meta, 'id'>
      )> }
    )> }
  )> }
);

export type S3PayoutUploadMutationVariables = Exact<{ [key: string]: never; }>;


export type S3PayoutUploadMutation = (
  { __typename?: 'Mutation' }
  & { s3UploadPayoutInvoice?: Maybe<(
    { __typename?: 'S3UploadRequestMutationResponse' }
    & { node?: Maybe<(
      { __typename?: 'S3UploadRequest' }
      & Pick<S3UploadRequest, 'uploadUrl'>
      & { meta?: Maybe<(
        { __typename?: 'S3Meta' }
        & Pick<S3Meta, 'id'>
      )> }
    )> }
  )> }
);

export type AppOrgUpdateVariables = Exact<{
  id: Scalars['ID'];
  businessName: Scalars['String'];
  businessEmail?: Maybe<Scalars['String']>;
  supportEmail?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
  emergencyDeveloperEmail?: Maybe<Scalars['String']>;
  emergencyDeveloperPhoneNumber: Scalars['String'];
  termsApiAgreed: Scalars['Boolean'];
  termsPartnerAgreed: Scalars['Boolean'];
}>;


export type AppOrgUpdate = (
  { __typename?: 'Mutation' }
  & { appOrgUpdate?: Maybe<(
    { __typename?: 'AppOrganizationMutationResponse' }
    & { node?: Maybe<(
      { __typename?: 'AppOrganization' }
      & Pick<AppOrganization, 'id' | 'businessName' | 'businessEmail' | 'supportEmail' | 'phoneNumber' | 'websiteUrl' | 'emergencyDeveloperEmail' | 'emergencyDeveloperPhoneNumber' | 'termsApiAgreed' | 'termsPartnerAgreed'>
    )> }
  )> }
);

export type UpdatePayoutSettingsVariables = Exact<{
  payoutSettings: PayoutSettingsInput;
}>;


export type UpdatePayoutSettings = (
  { __typename?: 'Mutation' }
  & { payoutSettingsUpdate?: Maybe<(
    { __typename?: 'PayoutSettingsTypeMutationResponse' }
    & Pick<PayoutSettingsTypeMutationResponse, 'successful'>
    & { node?: Maybe<(
      { __typename?: 'PayoutSettingsType' }
      & PayoutSettingsCommon
    )> }
  )> }
);

export type SubmitPayoutRequestVariables = Exact<{
  fileInput: AppFileInputInput;
}>;


export type SubmitPayoutRequest = (
  { __typename?: 'Mutation' }
  & { submitPayoutRequest?: Maybe<(
    { __typename?: 'AppStorePayoutTypeMutationResponse' }
    & Pick<AppStorePayoutTypeMutationResponse, 'successful'>
    & { node?: Maybe<(
      { __typename?: 'AppStorePayoutType' }
      & Pick<AppStorePayoutType, 'id'>
    )> }
  )> }
);

export type UpdatePayoutRequestVariables = Exact<{
  id: Scalars['ID'];
  fileInput: AppFileInputInput;
}>;


export type UpdatePayoutRequest = (
  { __typename?: 'Mutation' }
  & { updatePayoutRequest?: Maybe<(
    { __typename?: 'AppStorePayoutTypeMutationResponse' }
    & Pick<AppStorePayoutTypeMutationResponse, 'successful'>
    & { node?: Maybe<(
      { __typename?: 'AppStorePayoutType' }
      & Pick<AppStorePayoutType, 'id'>
    )> }
  )> }
);

export type InvoiceFileDeleteVariables = Exact<{
  fileKey: Scalars['String'];
}>;


export type InvoiceFileDelete = (
  { __typename?: 'Mutation' }
  & { invoiceFileDelete?: Maybe<(
    { __typename?: 'ObjectMutationResponse' }
    & Pick<ObjectMutationResponse, 'successful'>
  )> }
);

export type WebhookCreateVariables = Exact<{
  appId: Scalars['ID'];
  topic: AppWebhookTopic;
  url: Scalars['String'];
}>;


export type WebhookCreate = (
  { __typename?: 'Mutation' }
  & { webhookCreate?: Maybe<(
    { __typename?: 'AppMutationResponse' }
    & { node?: Maybe<(
      { __typename?: 'App' }
      & Pick<App, 'id' | 'name' | 'creationDate' | 'status' | 'apiContactEmail' | 'numberOfInstallations' | 'appUrl' | 'redirectUrlWhitelist' | 'chargeType' | 'type' | 'installationCountries' | 'oneTimeChargeAmount' | 'freeTrialDays' | 'appReviewInstructions'>
      & { apiCredentials?: Maybe<(
        { __typename?: 'AppApiCredentials' }
        & Pick<AppApiCredentials, 'apiKey' | 'secretKey'>
      )>, webhookSubscriptions?: Maybe<Array<Maybe<(
        { __typename?: 'AppWebhookSubscription' }
        & Pick<AppWebhookSubscription, 'id' | 'creationDate' | 'topic' | 'url'>
      )>>>, pricePlans?: Maybe<Array<Maybe<(
        { __typename?: 'AppPricePlan' }
        & Pick<AppPricePlan, 'id' | 'creationDate' | 'name' | 'type' | 'discountedYearlyPrice' | 'monthlyAmount' | 'yearlyAmount'>
      )>>>, listings?: Maybe<Array<Maybe<(
        { __typename?: 'AppListing' }
        & Pick<AppListing, 'id' | 'creationDate' | 'name' | 'tagLine' | 'description' | 'searchTerms' | 'integrations' | 'promoVideoUrl' | 'includeKeyBenefitsImages' | 'supportEmail' | 'supportPhone' | 'websiteUrl' | 'privacyPolicyUrl' | 'termsOfServiceUrl'>
        & { icon?: Maybe<(
          { __typename?: 'AppImage' }
          & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl'>
        )>, screenShots?: Maybe<Array<Maybe<(
          { __typename?: 'AppScreenShotType' }
          & Pick<AppScreenShotType, 'type' | 'description'>
          & { image?: Maybe<(
            { __typename?: 'AppImage' }
            & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl'>
          )> }
        )>>>, keyBenefits?: Maybe<Array<Maybe<(
          { __typename?: 'AppKeyBenefitType' }
          & Pick<AppKeyBenefitType, 'title' | 'description'>
          & { image?: Maybe<(
            { __typename?: 'AppImage' }
            & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl'>
          )> }
        )>>>, pricePlans?: Maybe<Array<Maybe<(
          { __typename?: 'AppPricePlanDetailsType' }
          & Pick<AppPricePlanDetailsType, 'planId' | 'name' | 'features'>
        )>>> }
      )>>> }
    )> }
  )> }
);

export type WebhookUpdateVariables = Exact<{
  id: Scalars['ID'];
  topic: AppWebhookTopic;
  url: Scalars['String'];
}>;


export type WebhookUpdate = (
  { __typename?: 'Mutation' }
  & { webhookUpdate?: Maybe<(
    { __typename?: 'AppWebhookSubscriptionMutationResponse' }
    & { node?: Maybe<(
      { __typename?: 'AppWebhookSubscription' }
      & Pick<AppWebhookSubscription, 'id' | 'creationDate' | 'topic' | 'url'>
    )> }
  )> }
);

export type WebhookDeleteVariables = Exact<{
  id: Scalars['ID'];
}>;


export type WebhookDelete = (
  { __typename?: 'Mutation' }
  & { webhookDelete?: Maybe<(
    { __typename?: 'AppMutationResponse' }
    & { node?: Maybe<(
      { __typename?: 'App' }
      & Pick<App, 'id' | 'name' | 'creationDate' | 'status' | 'apiContactEmail' | 'numberOfInstallations' | 'appUrl' | 'redirectUrlWhitelist' | 'chargeType' | 'type' | 'installationCountries' | 'oneTimeChargeAmount' | 'freeTrialDays' | 'appReviewInstructions'>
      & { apiCredentials?: Maybe<(
        { __typename?: 'AppApiCredentials' }
        & Pick<AppApiCredentials, 'apiKey' | 'secretKey'>
      )>, webhookSubscriptions?: Maybe<Array<Maybe<(
        { __typename?: 'AppWebhookSubscription' }
        & Pick<AppWebhookSubscription, 'id' | 'creationDate' | 'topic' | 'url'>
      )>>>, pricePlans?: Maybe<Array<Maybe<(
        { __typename?: 'AppPricePlan' }
        & Pick<AppPricePlan, 'id' | 'creationDate' | 'name' | 'type' | 'discountedYearlyPrice' | 'monthlyAmount' | 'yearlyAmount'>
      )>>>, listings?: Maybe<Array<Maybe<(
        { __typename?: 'AppListing' }
        & Pick<AppListing, 'id' | 'creationDate' | 'name' | 'tagLine' | 'description' | 'searchTerms' | 'integrations' | 'promoVideoUrl' | 'includeKeyBenefitsImages' | 'supportEmail' | 'supportPhone' | 'websiteUrl' | 'privacyPolicyUrl' | 'termsOfServiceUrl'>
        & { icon?: Maybe<(
          { __typename?: 'AppImage' }
          & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl'>
        )>, screenShots?: Maybe<Array<Maybe<(
          { __typename?: 'AppScreenShotType' }
          & Pick<AppScreenShotType, 'type' | 'description'>
          & { image?: Maybe<(
            { __typename?: 'AppImage' }
            & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl'>
          )> }
        )>>>, keyBenefits?: Maybe<Array<Maybe<(
          { __typename?: 'AppKeyBenefitType' }
          & Pick<AppKeyBenefitType, 'title' | 'description'>
          & { image?: Maybe<(
            { __typename?: 'AppImage' }
            & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl'>
          )> }
        )>>>, pricePlans?: Maybe<Array<Maybe<(
          { __typename?: 'AppPricePlanDetailsType' }
          & Pick<AppPricePlanDetailsType, 'planId' | 'name' | 'features'>
        )>>> }
      )>>> }
    )> }
  )> }
);

export type AppCreateVariables = Exact<{
  name: Scalars['String'];
  apiContactEmail: Scalars['String'];
  appUrl?: Maybe<Scalars['String']>;
  redirectUrlWhitelist?: Maybe<Scalars['String']>;
  chargeType: AppChargeType;
  type: AppVisibilityType;
  installationCountries?: Maybe<Array<Maybe<Scalars['String']>>>;
  oneTimeChargeAmount?: Maybe<Scalars['Float']>;
  freeTrialDays?: Maybe<Scalars['Int']>;
  appReviewInstructions?: Maybe<Scalars['String']>;
}>;


export type AppCreate = (
  { __typename?: 'Mutation' }
  & { appCreate?: Maybe<(
    { __typename?: 'AppMutationResponse' }
    & { node?: Maybe<(
      { __typename?: 'App' }
      & Pick<App, 'id' | 'name' | 'apiContactEmail' | 'appUrl' | 'redirectUrlWhitelist' | 'chargeType' | 'type' | 'installationCountries' | 'oneTimeChargeAmount' | 'freeTrialDays' | 'appReviewInstructions'>
      & { apiCredentials?: Maybe<(
        { __typename?: 'AppApiCredentials' }
        & Pick<AppApiCredentials, 'apiKey' | 'secretKey'>
      )> }
    )> }
  )> }
);

export type AppDeleteVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AppDelete = (
  { __typename?: 'Mutation' }
  & { appDelete?: Maybe<(
    { __typename?: 'AppMutationResponse' }
    & { node?: Maybe<(
      { __typename?: 'App' }
      & Pick<App, 'id'>
    )> }
  )> }
);

export type AppUpdateVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  type: AppVisibilityType;
  apiContactEmail: Scalars['String'];
  appUrl?: Maybe<Scalars['String']>;
  redirectUrlWhitelist?: Maybe<Scalars['String']>;
  chargeType: AppChargeType;
  installationCountries?: Maybe<Array<Maybe<Scalars['String']>>>;
  oneTimeChargeAmount?: Maybe<Scalars['Float']>;
  freeTrialDays?: Maybe<Scalars['Int']>;
  appReviewInstructions?: Maybe<Scalars['String']>;
}>;


export type AppUpdate = (
  { __typename?: 'Mutation' }
  & { appUpdate?: Maybe<(
    { __typename?: 'AppMutationResponse' }
    & { node?: Maybe<(
      { __typename?: 'App' }
      & Pick<App, 'id' | 'name' | 'creationDate' | 'status' | 'apiContactEmail' | 'numberOfInstallations' | 'appUrl' | 'redirectUrlWhitelist' | 'chargeType' | 'type' | 'installationCountries' | 'oneTimeChargeAmount' | 'freeTrialDays' | 'appReviewInstructions'>
      & { apiCredentials?: Maybe<(
        { __typename?: 'AppApiCredentials' }
        & Pick<AppApiCredentials, 'apiKey' | 'secretKey'>
      )>, linkedVendor?: Maybe<(
        { __typename?: 'AppVendorType' }
        & Pick<AppVendorType, 'id' | 'name'>
      )>, pricePlans?: Maybe<Array<Maybe<(
        { __typename?: 'AppPricePlan' }
        & Pick<AppPricePlan, 'id' | 'creationDate' | 'name' | 'type' | 'discountedYearlyPrice' | 'monthlyAmount' | 'yearlyAmount'>
      )>>>, webhookSubscriptions?: Maybe<Array<Maybe<(
        { __typename?: 'AppWebhookSubscription' }
        & Pick<AppWebhookSubscription, 'id' | 'creationDate' | 'topic' | 'url'>
      )>>> }
    )> }
  )> }
);

export type AppCustomPublishVariables = Exact<{
  appId: Scalars['ID'];
}>;


export type AppCustomPublish = (
  { __typename?: 'Mutation' }
  & { appCustomPublish?: Maybe<(
    { __typename?: 'App' }
    & Pick<App, 'status'>
  )> }
);

export type AppCustomLinkToVendorVariables = Exact<{
  appId: Scalars['ID'];
  vendorId: Scalars['ID'];
}>;


export type AppCustomLinkToVendor = (
  { __typename?: 'Mutation' }
  & { appCustomLinkToVendor?: Maybe<(
    { __typename?: 'AppMutationResponse' }
    & { node?: Maybe<(
      { __typename?: 'App' }
      & Pick<App, 'id' | 'name' | 'creationDate' | 'status' | 'apiContactEmail' | 'numberOfInstallations' | 'appUrl' | 'redirectUrlWhitelist' | 'chargeType' | 'type' | 'installationCountries' | 'oneTimeChargeAmount' | 'freeTrialDays' | 'appReviewInstructions'>
      & { apiCredentials?: Maybe<(
        { __typename?: 'AppApiCredentials' }
        & Pick<AppApiCredentials, 'apiKey' | 'secretKey'>
      )>, linkedVendor?: Maybe<(
        { __typename?: 'AppVendorType' }
        & Pick<AppVendorType, 'id' | 'name'>
      )>, pricePlans?: Maybe<Array<Maybe<(
        { __typename?: 'AppPricePlan' }
        & Pick<AppPricePlan, 'id' | 'creationDate' | 'name' | 'type' | 'discountedYearlyPrice' | 'monthlyAmount' | 'yearlyAmount'>
      )>>>, listings?: Maybe<Array<Maybe<(
        { __typename?: 'AppListing' }
        & Pick<AppListing, 'id' | 'creationDate' | 'name' | 'tagLine' | 'description' | 'searchTerms' | 'integrations' | 'promoVideoUrl' | 'includeKeyBenefitsImages' | 'supportEmail' | 'supportPhone' | 'websiteUrl' | 'privacyPolicyUrl' | 'termsOfServiceUrl'>
        & { icon?: Maybe<(
          { __typename?: 'AppImage' }
          & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl'>
        )>, screenShots?: Maybe<Array<Maybe<(
          { __typename?: 'AppScreenShotType' }
          & Pick<AppScreenShotType, 'type' | 'description'>
          & { image?: Maybe<(
            { __typename?: 'AppImage' }
            & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl'>
          )> }
        )>>>, keyBenefits?: Maybe<Array<Maybe<(
          { __typename?: 'AppKeyBenefitType' }
          & Pick<AppKeyBenefitType, 'title' | 'description'>
          & { image?: Maybe<(
            { __typename?: 'AppImage' }
            & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl'>
          )> }
        )>>>, pricePlans?: Maybe<Array<Maybe<(
          { __typename?: 'AppPricePlanDetailsType' }
          & Pick<AppPricePlanDetailsType, 'planId' | 'name' | 'features'>
        )>>> }
      )>>> }
    )> }
  )> }
);

export type AppTestUninstallVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AppTestUninstall = (
  { __typename?: 'Mutation' }
  & { appUninstallTest?: Maybe<(
    { __typename?: 'AppMutationResponse' }
    & { node?: Maybe<(
      { __typename?: 'App' }
      & Pick<App, 'id' | 'name' | 'creationDate' | 'status' | 'apiContactEmail' | 'numberOfInstallations' | 'appUrl' | 'redirectUrlWhitelist' | 'chargeType' | 'type' | 'installationCountries' | 'oneTimeChargeAmount' | 'freeTrialDays' | 'appReviewInstructions'>
      & { apiCredentials?: Maybe<(
        { __typename?: 'AppApiCredentials' }
        & Pick<AppApiCredentials, 'apiKey' | 'secretKey'>
      )>, testInstallation?: Maybe<(
        { __typename?: 'AppInstallation' }
        & Pick<AppInstallation, 'id' | 'creationDate'>
      )>, pricePlans?: Maybe<Array<Maybe<(
        { __typename?: 'AppPricePlan' }
        & Pick<AppPricePlan, 'id' | 'creationDate' | 'name' | 'type' | 'discountedYearlyPrice' | 'monthlyAmount' | 'yearlyAmount'>
      )>>>, listings?: Maybe<Array<Maybe<(
        { __typename?: 'AppListing' }
        & Pick<AppListing, 'id' | 'creationDate' | 'name' | 'tagLine' | 'description' | 'searchTerms' | 'integrations' | 'promoVideoUrl' | 'includeKeyBenefitsImages' | 'supportEmail' | 'supportPhone' | 'websiteUrl' | 'privacyPolicyUrl' | 'termsOfServiceUrl'>
        & { icon?: Maybe<(
          { __typename?: 'AppImage' }
          & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl'>
        )>, screenShots?: Maybe<Array<Maybe<(
          { __typename?: 'AppScreenShotType' }
          & Pick<AppScreenShotType, 'type' | 'description'>
          & { image?: Maybe<(
            { __typename?: 'AppImage' }
            & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl'>
          )> }
        )>>>, keyBenefits?: Maybe<Array<Maybe<(
          { __typename?: 'AppKeyBenefitType' }
          & Pick<AppKeyBenefitType, 'title' | 'description'>
          & { image?: Maybe<(
            { __typename?: 'AppImage' }
            & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl'>
          )> }
        )>>>, pricePlans?: Maybe<Array<Maybe<(
          { __typename?: 'AppPricePlanDetailsType' }
          & Pick<AppPricePlanDetailsType, 'planId' | 'name' | 'features'>
        )>>> }
      )>>> }
    )> }
  )> }
);

export type AppSubmitForReviewVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AppSubmitForReview = (
  { __typename?: 'Mutation' }
  & { appSubmitForReview?: Maybe<(
    { __typename?: 'AppMutationResponse' }
    & { node?: Maybe<(
      { __typename?: 'App' }
      & Pick<App, 'id' | 'name' | 'creationDate' | 'status' | 'apiContactEmail' | 'numberOfInstallations' | 'appUrl' | 'redirectUrlWhitelist' | 'chargeType' | 'type' | 'installationCountries' | 'oneTimeChargeAmount' | 'freeTrialDays' | 'appReviewInstructions'>
      & { apiCredentials?: Maybe<(
        { __typename?: 'AppApiCredentials' }
        & Pick<AppApiCredentials, 'apiKey' | 'secretKey'>
      )>, pricePlans?: Maybe<Array<Maybe<(
        { __typename?: 'AppPricePlan' }
        & Pick<AppPricePlan, 'id' | 'creationDate' | 'name' | 'type' | 'discountedYearlyPrice' | 'monthlyAmount' | 'yearlyAmount'>
      )>>>, listings?: Maybe<Array<Maybe<(
        { __typename?: 'AppListing' }
        & Pick<AppListing, 'id' | 'creationDate' | 'name' | 'tagLine' | 'description' | 'searchTerms' | 'integrations' | 'promoVideoUrl' | 'includeKeyBenefitsImages' | 'supportEmail' | 'supportPhone' | 'websiteUrl' | 'privacyPolicyUrl' | 'termsOfServiceUrl'>
        & { icon?: Maybe<(
          { __typename?: 'AppImage' }
          & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl'>
        )>, screenShots?: Maybe<Array<Maybe<(
          { __typename?: 'AppScreenShotType' }
          & Pick<AppScreenShotType, 'type' | 'description'>
          & { image?: Maybe<(
            { __typename?: 'AppImage' }
            & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl'>
          )> }
        )>>>, keyBenefits?: Maybe<Array<Maybe<(
          { __typename?: 'AppKeyBenefitType' }
          & Pick<AppKeyBenefitType, 'title' | 'description'>
          & { image?: Maybe<(
            { __typename?: 'AppImage' }
            & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl'>
          )> }
        )>>>, pricePlans?: Maybe<Array<Maybe<(
          { __typename?: 'AppPricePlanDetailsType' }
          & Pick<AppPricePlanDetailsType, 'planId' | 'name' | 'features'>
        )>>> }
      )>>> }
    )> }
  )> }
);

export type AppListingCreateVariables = Exact<{
  appId: Scalars['ID'];
  name: Scalars['String'];
  tagLine: Scalars['String'];
  description: Scalars['String'];
  searchTerms?: Maybe<Array<Maybe<Scalars['String']>>>;
  integrations?: Maybe<Array<Maybe<Scalars['String']>>>;
  promoVideoUrl?: Maybe<Scalars['String']>;
  includeKeyBenefitsImages: Scalars['Boolean'];
  supportEmail: Scalars['String'];
  supportPhone?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
  privacyPolicyUrl?: Maybe<Scalars['String']>;
  termsOfServiceUrl?: Maybe<Scalars['String']>;
  icon?: Maybe<AppImageUpdateInput>;
  screenShots?: Maybe<Array<Maybe<AppScreenShotUpdateInput>>>;
  keyBenefits?: Maybe<Array<Maybe<AppKeyBenefitUpdateInput>>>;
  pricePlans?: Maybe<Array<Maybe<AppPricePlanDetailsUpdateInput>>>;
  showContactDetails: Scalars['Boolean'];
  offerDemoRequest: Scalars['Boolean'];
}>;


export type AppListingCreate = (
  { __typename?: 'Mutation' }
  & { appListingCreate?: Maybe<(
    { __typename?: 'AppMutationResponse' }
    & { node?: Maybe<(
      { __typename?: 'App' }
      & Pick<App, 'id' | 'name' | 'creationDate' | 'status' | 'apiContactEmail' | 'numberOfInstallations' | 'appUrl' | 'redirectUrlWhitelist' | 'chargeType' | 'installationCountries' | 'oneTimeChargeAmount' | 'freeTrialDays' | 'appReviewInstructions'>
      & { apiCredentials?: Maybe<(
        { __typename?: 'AppApiCredentials' }
        & Pick<AppApiCredentials, 'apiKey' | 'secretKey'>
      )>, pricePlans?: Maybe<Array<Maybe<(
        { __typename?: 'AppPricePlan' }
        & Pick<AppPricePlan, 'id' | 'creationDate' | 'name' | 'type' | 'discountedYearlyPrice' | 'monthlyAmount' | 'yearlyAmount'>
      )>>>, listings?: Maybe<Array<Maybe<(
        { __typename?: 'AppListing' }
        & Pick<AppListing, 'id' | 'creationDate' | 'name' | 'tagLine' | 'description' | 'searchTerms' | 'integrations' | 'promoVideoUrl' | 'includeKeyBenefitsImages' | 'supportEmail' | 'supportPhone' | 'websiteUrl' | 'privacyPolicyUrl' | 'termsOfServiceUrl' | 'showContactDetails' | 'offerDemoRequest'>
        & { icon?: Maybe<(
          { __typename?: 'AppImage' }
          & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl'>
        )>, screenShots?: Maybe<Array<Maybe<(
          { __typename?: 'AppScreenShotType' }
          & Pick<AppScreenShotType, 'type' | 'description'>
          & { image?: Maybe<(
            { __typename?: 'AppImage' }
            & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl'>
          )> }
        )>>>, keyBenefits?: Maybe<Array<Maybe<(
          { __typename?: 'AppKeyBenefitType' }
          & Pick<AppKeyBenefitType, 'title' | 'description'>
          & { image?: Maybe<(
            { __typename?: 'AppImage' }
            & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl'>
          )> }
        )>>>, pricePlans?: Maybe<Array<Maybe<(
          { __typename?: 'AppPricePlanDetailsType' }
          & Pick<AppPricePlanDetailsType, 'planId' | 'name' | 'features'>
        )>>> }
      )>>> }
    )> }
  )> }
);

export type AppListingUpdateVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  tagLine: Scalars['String'];
  description: Scalars['String'];
  searchTerms?: Maybe<Array<Maybe<Scalars['String']>>>;
  integrations?: Maybe<Array<Maybe<Scalars['String']>>>;
  promoVideoUrl?: Maybe<Scalars['String']>;
  includeKeyBenefitsImages: Scalars['Boolean'];
  supportEmail: Scalars['String'];
  supportPhone?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
  privacyPolicyUrl?: Maybe<Scalars['String']>;
  termsOfServiceUrl?: Maybe<Scalars['String']>;
  icon?: Maybe<AppImageUpdateInput>;
  screenShots?: Maybe<Array<Maybe<AppScreenShotUpdateInput>>>;
  keyBenefits?: Maybe<Array<Maybe<AppKeyBenefitUpdateInput>>>;
  pricePlans?: Maybe<Array<Maybe<AppPricePlanDetailsUpdateInput>>>;
  showContactDetails: Scalars['Boolean'];
  offerDemoRequest: Scalars['Boolean'];
}>;


export type AppListingUpdate = (
  { __typename?: 'Mutation' }
  & { appListingUpdate?: Maybe<(
    { __typename?: 'AppMutationResponse' }
    & { node?: Maybe<(
      { __typename?: 'App' }
      & Pick<App, 'id' | 'name' | 'creationDate' | 'status' | 'apiContactEmail' | 'numberOfInstallations' | 'appUrl' | 'redirectUrlWhitelist' | 'chargeType' | 'type' | 'installationCountries' | 'oneTimeChargeAmount' | 'freeTrialDays' | 'appReviewInstructions'>
      & { apiCredentials?: Maybe<(
        { __typename?: 'AppApiCredentials' }
        & Pick<AppApiCredentials, 'apiKey' | 'secretKey'>
      )>, webhookSubscriptions?: Maybe<Array<Maybe<(
        { __typename?: 'AppWebhookSubscription' }
        & Pick<AppWebhookSubscription, 'id' | 'creationDate' | 'topic' | 'url'>
      )>>>, pricePlans?: Maybe<Array<Maybe<(
        { __typename?: 'AppPricePlan' }
        & Pick<AppPricePlan, 'id' | 'creationDate' | 'name' | 'type' | 'discountedYearlyPrice' | 'monthlyAmount' | 'yearlyAmount'>
      )>>>, listings?: Maybe<Array<Maybe<(
        { __typename?: 'AppListing' }
        & Pick<AppListing, 'id' | 'creationDate' | 'name' | 'tagLine' | 'description' | 'searchTerms' | 'integrations' | 'promoVideoUrl' | 'includeKeyBenefitsImages' | 'supportEmail' | 'supportPhone' | 'websiteUrl' | 'privacyPolicyUrl' | 'termsOfServiceUrl' | 'showContactDetails' | 'offerDemoRequest'>
        & { icon?: Maybe<(
          { __typename?: 'AppImage' }
          & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl'>
        )>, screenShots?: Maybe<Array<Maybe<(
          { __typename?: 'AppScreenShotType' }
          & Pick<AppScreenShotType, 'type' | 'description'>
          & { image?: Maybe<(
            { __typename?: 'AppImage' }
            & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl'>
          )> }
        )>>>, keyBenefits?: Maybe<Array<Maybe<(
          { __typename?: 'AppKeyBenefitType' }
          & Pick<AppKeyBenefitType, 'title' | 'description'>
          & { image?: Maybe<(
            { __typename?: 'AppImage' }
            & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl'>
          )> }
        )>>>, pricePlans?: Maybe<Array<Maybe<(
          { __typename?: 'AppPricePlanDetailsType' }
          & Pick<AppPricePlanDetailsType, 'planId' | 'name' | 'features'>
        )>>> }
      )>>> }
    )> }
  )> }
);

export type AppListingDeleteVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AppListingDelete = (
  { __typename?: 'Mutation' }
  & { appListingDelete?: Maybe<(
    { __typename?: 'AppMutationResponse' }
    & { node?: Maybe<(
      { __typename?: 'App' }
      & Pick<App, 'id' | 'name' | 'creationDate' | 'status' | 'apiContactEmail' | 'numberOfInstallations' | 'appUrl' | 'redirectUrlWhitelist' | 'chargeType' | 'type' | 'installationCountries' | 'oneTimeChargeAmount' | 'freeTrialDays' | 'appReviewInstructions'>
      & { apiCredentials?: Maybe<(
        { __typename?: 'AppApiCredentials' }
        & Pick<AppApiCredentials, 'apiKey' | 'secretKey'>
      )>, pricePlans?: Maybe<Array<Maybe<(
        { __typename?: 'AppPricePlan' }
        & Pick<AppPricePlan, 'id' | 'creationDate' | 'name' | 'type' | 'discountedYearlyPrice' | 'monthlyAmount' | 'yearlyAmount'>
      )>>>, listings?: Maybe<Array<Maybe<(
        { __typename?: 'AppListing' }
        & Pick<AppListing, 'id' | 'creationDate' | 'name' | 'tagLine' | 'description' | 'searchTerms' | 'integrations' | 'promoVideoUrl' | 'includeKeyBenefitsImages' | 'supportEmail' | 'supportPhone' | 'websiteUrl' | 'privacyPolicyUrl' | 'termsOfServiceUrl'>
        & { icon?: Maybe<(
          { __typename?: 'AppImage' }
          & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl'>
        )>, screenShots?: Maybe<Array<Maybe<(
          { __typename?: 'AppScreenShotType' }
          & Pick<AppScreenShotType, 'type' | 'description'>
          & { image?: Maybe<(
            { __typename?: 'AppImage' }
            & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl'>
          )> }
        )>>>, keyBenefits?: Maybe<Array<Maybe<(
          { __typename?: 'AppKeyBenefitType' }
          & Pick<AppKeyBenefitType, 'title' | 'description'>
          & { image?: Maybe<(
            { __typename?: 'AppImage' }
            & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl'>
          )> }
        )>>>, pricePlans?: Maybe<Array<Maybe<(
          { __typename?: 'AppPricePlanDetailsType' }
          & Pick<AppPricePlanDetailsType, 'planId' | 'name' | 'features'>
        )>>> }
      )>>> }
    )> }
  )> }
);

export type AppListingImageDeleteVariables = Exact<{
  id: Scalars['ID'];
  imageType: AppListingImageType;
  imageKey: Scalars['String'];
}>;


export type AppListingImageDelete = (
  { __typename?: 'Mutation' }
  & { appListingImageDelete?: Maybe<(
    { __typename?: 'AppMutationResponse' }
    & { node?: Maybe<(
      { __typename?: 'App' }
      & Pick<App, 'id' | 'name' | 'creationDate' | 'status' | 'apiContactEmail' | 'numberOfInstallations' | 'appUrl' | 'redirectUrlWhitelist' | 'chargeType' | 'type' | 'installationCountries' | 'oneTimeChargeAmount' | 'freeTrialDays' | 'appReviewInstructions'>
      & { apiCredentials?: Maybe<(
        { __typename?: 'AppApiCredentials' }
        & Pick<AppApiCredentials, 'apiKey' | 'secretKey'>
      )>, pricePlans?: Maybe<Array<Maybe<(
        { __typename?: 'AppPricePlan' }
        & Pick<AppPricePlan, 'id' | 'creationDate' | 'name' | 'type' | 'discountedYearlyPrice' | 'monthlyAmount' | 'yearlyAmount'>
      )>>>, listings?: Maybe<Array<Maybe<(
        { __typename?: 'AppListing' }
        & Pick<AppListing, 'id' | 'creationDate' | 'name' | 'tagLine' | 'description' | 'searchTerms' | 'integrations' | 'promoVideoUrl' | 'includeKeyBenefitsImages' | 'supportEmail' | 'supportPhone' | 'websiteUrl' | 'privacyPolicyUrl' | 'termsOfServiceUrl'>
        & { icon?: Maybe<(
          { __typename?: 'AppImage' }
          & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl'>
        )>, screenShots?: Maybe<Array<Maybe<(
          { __typename?: 'AppScreenShotType' }
          & Pick<AppScreenShotType, 'type' | 'description'>
          & { image?: Maybe<(
            { __typename?: 'AppImage' }
            & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl'>
          )> }
        )>>>, keyBenefits?: Maybe<Array<Maybe<(
          { __typename?: 'AppKeyBenefitType' }
          & Pick<AppKeyBenefitType, 'title' | 'description'>
          & { image?: Maybe<(
            { __typename?: 'AppImage' }
            & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl'>
          )> }
        )>>>, pricePlans?: Maybe<Array<Maybe<(
          { __typename?: 'AppPricePlanDetailsType' }
          & Pick<AppPricePlanDetailsType, 'planId' | 'name' | 'features'>
        )>>> }
      )>>> }
    )> }
  )> }
);

export type AppPricePlanCreateVariables = Exact<{
  appId: Scalars['ID'];
  name: Scalars['String'];
  type: AppPricePlanEnumType;
  discountedYearlyPrice: Scalars['Boolean'];
  monthlyAmount?: Maybe<Scalars['Float']>;
  yearlyAmount?: Maybe<Scalars['Float']>;
}>;


export type AppPricePlanCreate = (
  { __typename?: 'Mutation' }
  & { appPricePlanCreate?: Maybe<(
    { __typename?: 'AppMutationResponse' }
    & { node?: Maybe<(
      { __typename?: 'App' }
      & Pick<App, 'id' | 'name' | 'creationDate' | 'status' | 'apiContactEmail' | 'numberOfInstallations' | 'appUrl' | 'redirectUrlWhitelist' | 'chargeType' | 'type' | 'installationCountries' | 'oneTimeChargeAmount' | 'freeTrialDays' | 'appReviewInstructions'>
      & { apiCredentials?: Maybe<(
        { __typename?: 'AppApiCredentials' }
        & Pick<AppApiCredentials, 'apiKey' | 'secretKey'>
      )>, pricePlans?: Maybe<Array<Maybe<(
        { __typename?: 'AppPricePlan' }
        & Pick<AppPricePlan, 'id' | 'creationDate' | 'name' | 'type' | 'discountedYearlyPrice' | 'monthlyAmount' | 'yearlyAmount'>
      )>>> }
    )> }
  )> }
);

export type AppPricePlanUpdateVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  type: AppPricePlanEnumType;
  discountedYearlyPrice: Scalars['Boolean'];
  monthlyAmount?: Maybe<Scalars['Float']>;
  yearlyAmount?: Maybe<Scalars['Float']>;
}>;


export type AppPricePlanUpdate = (
  { __typename?: 'Mutation' }
  & { appPricePlanUpdate?: Maybe<(
    { __typename?: 'AppPricePlanMutationResponse' }
    & { node?: Maybe<(
      { __typename?: 'AppPricePlan' }
      & Pick<AppPricePlan, 'id' | 'appId' | 'creationDate' | 'name' | 'type' | 'discountedYearlyPrice' | 'monthlyAmount' | 'yearlyAmount'>
    )> }
  )> }
);

export type AppPricePlanDeleteVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AppPricePlanDelete = (
  { __typename?: 'Mutation' }
  & { appPricePlanDelete?: Maybe<(
    { __typename?: 'AppMutationResponse' }
    & { node?: Maybe<(
      { __typename?: 'App' }
      & Pick<App, 'id' | 'name' | 'creationDate' | 'status' | 'apiContactEmail' | 'numberOfInstallations' | 'appUrl' | 'redirectUrlWhitelist' | 'chargeType' | 'type' | 'installationCountries' | 'oneTimeChargeAmount' | 'freeTrialDays' | 'appReviewInstructions'>
      & { apiCredentials?: Maybe<(
        { __typename?: 'AppApiCredentials' }
        & Pick<AppApiCredentials, 'apiKey' | 'secretKey'>
      )>, pricePlans?: Maybe<Array<Maybe<(
        { __typename?: 'AppPricePlan' }
        & Pick<AppPricePlan, 'id' | 'creationDate' | 'name' | 'type' | 'discountedYearlyPrice' | 'monthlyAmount' | 'yearlyAmount'>
      )>>> }
    )> }
  )> }
);

export type AppDeveloperLogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type AppDeveloperLogoutMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'appAccountLogout'>
);

export type AppDeveloperLoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type AppDeveloperLoginMutation = (
  { __typename?: 'Mutation' }
  & { appAccountLogin?: Maybe<(
    { __typename?: 'AppUserAccountMutationResponse' }
    & { node?: Maybe<(
      { __typename?: 'AppUserAccount' }
      & Pick<AppUserAccount, 'id' | 'email' | 'firstName' | 'lastName' | 'orgId' | 'orgName' | 'accountOwner'>
    )> }
  )> }
);

export type AppDeveloperSignupMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  termsApiAgreed: Scalars['Boolean'];
  termsPartnerAgreed: Scalars['Boolean'];
}>;


export type AppDeveloperSignupMutation = (
  { __typename?: 'Mutation' }
  & { appAccountSignup?: Maybe<(
    { __typename?: 'AppUserAccountMutationResponse' }
    & { node?: Maybe<(
      { __typename?: 'AppUserAccount' }
      & Pick<AppUserAccount, 'id' | 'email' | 'firstName' | 'lastName' | 'orgId' | 'orgName'>
    )> }
  )> }
);

export type AppUserAccountUpdateVariables = Exact<{
  id: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password?: Maybe<Scalars['String']>;
}>;


export type AppUserAccountUpdate = (
  { __typename?: 'Mutation' }
  & { appAccountUserUpdate?: Maybe<(
    { __typename?: 'AppUserAccountMutationResponse' }
    & { node?: Maybe<(
      { __typename?: 'AppUserAccount' }
      & Pick<AppUserAccount, 'id' | 'email' | 'firstName' | 'lastName' | 'orgId' | 'orgName'>
    )> }
  )> }
);

export type AppUserAccountDeleteVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AppUserAccountDelete = (
  { __typename?: 'Mutation' }
  & { appAccountUserDelete?: Maybe<(
    { __typename?: 'AppUserAccountMutationResponse' }
    & { node?: Maybe<(
      { __typename?: 'AppUserAccount' }
      & Pick<AppUserAccount, 'id'>
    )> }
  )> }
);

export type AppUserAccountCreateVariables = Exact<{
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type AppUserAccountCreate = (
  { __typename?: 'Mutation' }
  & { appAccountUserCreate?: Maybe<(
    { __typename?: 'AppUserAccountMutationResponse' }
    & { node?: Maybe<(
      { __typename?: 'AppUserAccount' }
      & Pick<AppUserAccount, 'id' | 'email' | 'firstName' | 'lastName' | 'orgId' | 'orgName'>
    )> }
  )> }
);

export type AppUserAccountChangeOrgVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AppUserAccountChangeOrg = (
  { __typename?: 'Mutation' }
  & { appAccountUserChangeOrg?: Maybe<(
    { __typename?: 'AppUserAccountMutationResponse' }
    & { node?: Maybe<(
      { __typename?: 'AppUserAccount' }
      & Pick<AppUserAccount, 'id' | 'email' | 'firstName' | 'lastName' | 'orgId' | 'orgName' | 'adminUser' | 'organizationId'>
    )> }
  )> }
);

export type AppListingFragment = (
  { __typename?: 'AppListing' }
  & Pick<AppListing, 'id' | 'creationDate' | 'language' | 'name' | 'tagLine' | 'description' | 'searchTerms' | 'integrations' | 'promoVideoUrl' | 'includeKeyBenefitsImages' | 'supportEmail' | 'supportPhone' | 'websiteUrl' | 'privacyPolicyUrl' | 'termsOfServiceUrl' | 'offerDemoRequest' | 'showContactDetails'>
  & { icon?: Maybe<(
    { __typename?: 'AppImage' }
    & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl'>
  )>, screenShots?: Maybe<Array<Maybe<(
    { __typename?: 'AppScreenShotType' }
    & Pick<AppScreenShotType, 'type' | 'description'>
    & { image?: Maybe<(
      { __typename?: 'AppImage' }
      & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl'>
    )> }
  )>>>, keyBenefits?: Maybe<Array<Maybe<(
    { __typename?: 'AppKeyBenefitType' }
    & Pick<AppKeyBenefitType, 'title' | 'description'>
    & { image?: Maybe<(
      { __typename?: 'AppImage' }
      & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl'>
    )> }
  )>>>, pricePlans?: Maybe<Array<Maybe<(
    { __typename?: 'AppPricePlanDetailsType' }
    & Pick<AppPricePlanDetailsType, 'planId' | 'name' | 'features'>
    & { plan?: Maybe<(
      { __typename?: 'AppPricePlan' }
      & Pick<AppPricePlan, 'id' | 'appId' | 'creationDate' | 'name' | 'type' | 'monthlyAmount' | 'yearlyAmount' | 'discountedYearlyPrice'>
    )> }
  )>>> }
);

export type AppFragment = (
  { __typename?: 'App' }
  & Pick<App, 'id' | 'name' | 'creationDate' | 'status' | 'type' | 'apiContactEmail' | 'numberOfInstallations' | 'appUrl' | 'redirectUrlWhitelist' | 'chargeType' | 'installationCountries' | 'oneTimeChargeAmount' | 'freeTrialDays' | 'appReviewInstructions'>
  & { apiCredentials?: Maybe<(
    { __typename?: 'AppApiCredentials' }
    & Pick<AppApiCredentials, 'apiKey' | 'secretKey'>
  )>, linkedVendor?: Maybe<(
    { __typename?: 'AppVendorType' }
    & Pick<AppVendorType, 'id' | 'name'>
  )>, customInstallation?: Maybe<(
    { __typename?: 'AppInstallation' }
    & Pick<AppInstallation, 'id'>
  )>, testInstallation?: Maybe<(
    { __typename?: 'AppInstallation' }
    & Pick<AppInstallation, 'id' | 'creationDate'>
  )>, pricePlans?: Maybe<Array<Maybe<(
    { __typename?: 'AppPricePlan' }
    & Pick<AppPricePlan, 'id' | 'creationDate' | 'name' | 'type' | 'discountedYearlyPrice' | 'monthlyAmount' | 'yearlyAmount' | 'appId'>
  )>>>, webhookSubscriptions?: Maybe<Array<Maybe<(
    { __typename?: 'AppWebhookSubscription' }
    & Pick<AppWebhookSubscription, 'id' | 'creationDate' | 'topic' | 'url'>
  )>>>, listings?: Maybe<Array<Maybe<(
    { __typename?: 'AppListing' }
    & Pick<AppListing, 'id'>
    & AppListingFragment
  )>>> }
);

export type GetAppDashboardQueryVariables = Exact<{
  timestampFrom: Scalars['Long'];
  timestampTo: Scalars['Long'];
  split?: Maybe<AppDashboardSplitType>;
}>;


export type GetAppDashboardQuery = (
  { __typename?: 'Query' }
  & { AppDashboardQuery?: Maybe<(
    { __typename?: 'AppDashboard' }
    & { installations: Array<Maybe<(
      { __typename?: 'AppDashboardNamedDataType' }
      & Pick<AppDashboardNamedDataType, 'label' | 'amount'>
    )>>, uninstallations: Array<Maybe<(
      { __typename?: 'AppDashboardNamedDataType' }
      & Pick<AppDashboardNamedDataType, 'label' | 'amount'>
    )>>, installationsByCountry: Array<Maybe<(
      { __typename?: 'AppDashboardNamedDataType' }
      & Pick<AppDashboardNamedDataType, 'amount' | 'label'>
    )>> }
  )> }
);

export type AppOrgListQueryVariables = Exact<{ [key: string]: never; }>;


export type AppOrgListQuery = (
  { __typename?: 'Query' }
  & { GetOrganizations?: Maybe<Array<Maybe<(
    { __typename?: 'AppOrganization' }
    & Pick<AppOrganization, 'id' | 'businessName' | 'supportEmail' | 'organizationId'>
  )>>> }
);

export type AppOrgQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AppOrgQuery = (
  { __typename?: 'Query' }
  & { appOrg?: Maybe<(
    { __typename?: 'AppOrganization' }
    & Pick<AppOrganization, 'id' | 'businessName' | 'businessEmail' | 'supportEmail' | 'phoneNumber' | 'websiteUrl' | 'emergencyDeveloperEmail' | 'emergencyDeveloperPhoneNumber' | 'termsApiAgreed' | 'termsPartnerAgreed'>
  )> }
);

export type AppOrgStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type AppOrgStatusQuery = (
  { __typename?: 'Query' }
  & { appOrgStatus?: Maybe<(
    { __typename?: 'AppOrgStatus' }
    & Pick<AppOrgStatus, 'hasRejectedPayout' | 'hasUnclaimedPayout' | 'periodFrom' | 'periodTo' | 'hasValidPayoutSettings' | 'hasValidTaxForm' | 'payoutSettingsPreview' | 'amount' | 'displayAmount'>
  )> }
);

export type GetPayoutSettingsVariables = Exact<{ [key: string]: never; }>;


export type GetPayoutSettings = (
  { __typename?: 'Query' }
  & { getPayoutSettings?: Maybe<(
    { __typename?: 'PayoutSettingsType' }
    & PayoutSettingsCommon
  )> }
);

export type GetDeveloperPayoutsVariables = Exact<{
  after?: Maybe<Scalars['String']>;
  first: Scalars['Int'];
}>;


export type GetDeveloperPayouts = (
  { __typename?: 'Query' }
  & { getPayouts?: Maybe<(
    { __typename?: 'AppStorePayoutTypeConnection' }
    & Pick<AppStorePayoutTypeConnection, 'totalCount'>
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'AppStorePayoutTypeEdge' }
      & Pick<AppStorePayoutTypeEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'AppStorePayoutType' }
        & Pick<AppStorePayoutType, 'id' | 'amount' | 'creationDate' | 'invoiceDateFrom' | 'invoiceDateTo' | 'pdfInvoiceUrl' | 'status'>
      )> }
    )>>>, pageInfo?: Maybe<(
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    )> }
  )> }
);

export type GetDeveloperPayoutVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetDeveloperPayout = (
  { __typename?: 'Query' }
  & { getPayoutDetails?: Maybe<(
    { __typename?: 'AppStorePayoutType' }
    & Pick<AppStorePayoutType, 'status' | 'reason' | 'pdfInvoiceUrl'>
    & { payoutInvoice?: Maybe<(
      { __typename?: 'AppStorePayoutInvoiceType' }
      & Pick<AppStorePayoutInvoiceType, 'fileName' | 'fileType' | 's3Key' | 'id' | 'size'>
    )> }
  )> }
);

export type CurrenciesVariables = Exact<{ [key: string]: never; }>;


export type Currencies = (
  { __typename?: 'Query' }
  & { GetCurrencies?: Maybe<Array<Maybe<(
    { __typename?: 'CurrencyType' }
    & Pick<CurrencyType, 'label' | 'value'>
  )>>> }
);

export type AppListQueryVariables = Exact<{
  after?: Maybe<Scalars['String']>;
  first: Scalars['Int'];
}>;


export type AppListQuery = (
  { __typename?: 'Query' }
  & { apps?: Maybe<(
    { __typename?: 'AppConnection' }
    & Pick<AppConnection, 'totalCount'>
    & { pageInfo?: Maybe<(
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'startCursor' | 'hasPreviousPage' | 'hasNextPage'>
    )>, edges?: Maybe<Array<Maybe<(
      { __typename?: 'AppEdge' }
      & Pick<AppEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'App' }
        & Pick<App, 'id' | 'name' | 'creationDate' | 'status' | 'type' | 'numberOfInstallations'>
        & { linkedVendor?: Maybe<(
          { __typename?: 'AppVendorType' }
          & Pick<AppVendorType, 'id' | 'name'>
        )> }
      )> }
    )>>> }
  )> }
);

export type AppQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AppQuery = (
  { __typename?: 'Query' }
  & { app?: Maybe<(
    { __typename?: 'App' }
    & Pick<App, 'id'>
    & AppFragment
  )> }
);

export type AppValidationReportQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AppValidationReportQuery = (
  { __typename?: 'Query' }
  & { appValidationReport?: Maybe<(
    { __typename?: 'AppValidationReportType' }
    & Pick<AppValidationReportType, 'valid' | 'testInstallationSuccessful'>
    & { items?: Maybe<Array<Maybe<(
      { __typename?: 'AppValidationItemType' }
      & Pick<AppValidationItemType, 'valid' | 'type' | 'message'>
    )>>>, listingsReports?: Maybe<Array<Maybe<(
      { __typename?: 'AppListingValidationReportType' }
      & Pick<AppListingValidationReportType, 'listingId' | 'language' | 'valid'>
      & { items?: Maybe<Array<Maybe<(
        { __typename?: 'AppValidationItemType' }
        & Pick<AppValidationItemType, 'valid' | 'type' | 'message'>
      )>>> }
    )>>> }
  )> }
);

export type AppUserAccountQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AppUserAccountQuery = (
  { __typename?: 'Query' }
  & { appAccountUser?: Maybe<(
    { __typename?: 'AppUserAccount' }
    & Pick<AppUserAccount, 'id' | 'email' | 'firstName' | 'lastName' | 'orgId' | 'orgName' | 'organizationId' | 'adminUser'>
  )> }
);

export type UserListQueryVariables = Exact<{
  filter?: Maybe<AppUserAccountFilterInput>;
  sorting?: Maybe<AppUserAccountSortInput>;
  after?: Maybe<Scalars['String']>;
  first: Scalars['Int'];
}>;


export type UserListQuery = (
  { __typename?: 'Query' }
  & { appAccountUserList?: Maybe<(
    { __typename?: 'AppUserAccountConnection' }
    & Pick<AppUserAccountConnection, 'totalCount'>
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'AppUserAccountEdge' }
      & Pick<AppUserAccountEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'AppUserAccount' }
        & Pick<AppUserAccount, 'id' | 'email' | 'firstName' | 'lastName' | 'accountOwner'>
      )> }
    )>>> }
  )> }
);

export type PublicAppListingsQueryVariables = Exact<{
  filter?: Maybe<AppListingFilterInput>;
  sorting?: Maybe<AppListingSortInput>;
  after?: Maybe<Scalars['String']>;
  first: Scalars['Int'];
}>;


export type PublicAppListingsQuery = (
  { __typename?: 'Query' }
  & { publicAppListings?: Maybe<(
    { __typename?: 'PublicAppListingConnection' }
    & Pick<PublicAppListingConnection, 'totalCount'>
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'PublicAppListingEdge' }
      & Pick<PublicAppListingEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'PublicAppListing' }
        & Pick<PublicAppListing, 'id' | 'appId' | 'name' | 'tagLine' | 'chargeType' | 'freeTrialDays' | 'oneTimeChargeAmount'>
        & { pricePlans?: Maybe<Array<Maybe<(
          { __typename?: 'AppPricePlanDetailsType' }
          & Pick<AppPricePlanDetailsType, 'planId' | 'name'>
          & { plan?: Maybe<(
            { __typename?: 'AppPricePlan' }
            & Pick<AppPricePlan, 'oneTimeAmount' | 'monthlyAmount' | 'yearlyAmount' | 'bookingFeePercentage'>
          )> }
        )>>>, icon?: Maybe<(
          { __typename?: 'AppImage' }
          & Pick<AppImage, 'sourceUrl'>
        )> }
      )> }
    )>>> }
  )> }
);

export type PublicAppListingByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PublicAppListingByIdQuery = (
  { __typename?: 'Query' }
  & { publicAppListing?: Maybe<(
    { __typename?: 'PublicAppListing' }
    & Pick<PublicAppListing, 'id' | 'appId' | 'name' | 'tagLine' | 'description' | 'promoVideoUrl' | 'supportEmail' | 'supportPhone' | 'websiteUrl' | 'privacyPolicyUrl' | 'termsOfServiceUrl' | 'includeKeyBenefitsImages' | 'appUrl' | 'chargeType' | 'freeTrialDays' | 'oneTimeChargeAmount'>
    & { organization?: Maybe<(
      { __typename?: 'PublicAppOrg' }
      & Pick<PublicAppOrg, 'id' | 'businessName' | 'businessEmail' | 'websiteUrl' | 'phoneNumber' | 'supportEmail'>
    )>, icon?: Maybe<(
      { __typename?: 'AppImage' }
      & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl' | 'temp'>
    )>, screenShots?: Maybe<Array<Maybe<(
      { __typename?: 'AppScreenShotType' }
      & Pick<AppScreenShotType, 'type' | 'description'>
      & { image?: Maybe<(
        { __typename?: 'AppImage' }
        & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl'>
      )> }
    )>>>, keyBenefits?: Maybe<Array<Maybe<(
      { __typename?: 'AppKeyBenefitType' }
      & Pick<AppKeyBenefitType, 'title' | 'description'>
      & { image?: Maybe<(
        { __typename?: 'AppImage' }
        & Pick<AppImage, 's3Key' | 'fileName' | 'fileType' | 'height' | 'width' | 'size' | 'sourceUrl'>
      )> }
    )>>>, pricePlans?: Maybe<Array<Maybe<(
      { __typename?: 'AppPricePlanDetailsType' }
      & Pick<AppPricePlanDetailsType, 'planId' | 'name' | 'features'>
      & { plan?: Maybe<(
        { __typename?: 'AppPricePlan' }
        & Pick<AppPricePlan, 'id' | 'type' | 'monthlyAmount' | 'yearlyAmount' | 'discountedYearlyPrice' | 'bookingFeePercentage'>
      )> }
    )>>> }
  )> }
);

export type AppInstallationsQueryVariables = Exact<{
  appId: Scalars['ID'];
  after?: Maybe<Scalars['String']>;
  first: Scalars['Int'];
}>;


export type AppInstallationsQuery = (
  { __typename?: 'Query' }
  & { installations?: Maybe<(
    { __typename?: 'AppInstallationConnection' }
    & Pick<AppInstallationConnection, 'totalCount'>
    & { pageInfo?: Maybe<(
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'startCursor' | 'hasPreviousPage' | 'hasNextPage'>
    )>, edges?: Maybe<Array<Maybe<(
      { __typename?: 'AppInstallationEdge' }
      & Pick<AppInstallationEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'AppInstallation' }
        & Pick<AppInstallation, 'id' | 'creationDate'>
        & { vendor: (
          { __typename?: 'AppVendorType' }
          & Pick<AppVendorType, 'id' | 'name'>
        ) }
      )> }
    )>>> }
  )> }
);

export type AppInstallationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AppInstallationQuery = (
  { __typename?: 'Query' }
  & { installation?: Maybe<(
    { __typename?: 'AppInstallation' }
    & Pick<AppInstallation, 'id' | 'creationDate'>
    & { vendor: (
      { __typename?: 'AppVendorType' }
      & Pick<AppVendorType, 'id' | 'name'>
    ), oldRestApiCredentials?: Maybe<(
      { __typename?: 'OldRestApiCrendentials' }
      & Pick<OldRestApiCrendentials, 'accessKey' | 'secretKey'>
    )> }
  )> }
);

export type AppVendorSearchQueryVariables = Exact<{
  query?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first: Scalars['Int'];
}>;


export type AppVendorSearchQuery = (
  { __typename?: 'Query' }
  & { appVendorSearch?: Maybe<(
    { __typename?: 'AppVendorTypeConnection' }
    & Pick<AppVendorTypeConnection, 'totalCount'>
    & { edges?: Maybe<Array<Maybe<(
      { __typename?: 'AppVendorTypeEdge' }
      & Pick<AppVendorTypeEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'AppVendorType' }
        & Pick<AppVendorType, 'id' | 'name'>
      )> }
    )>>> }
  )> }
);

export const AppListingFragmentCommon = gql`
    fragment AppListingFragmentCommon on AppListing {
  id
  creationDate
  language
  name
  tagLine
  description
  searchTerms
  integrations
  promoVideoUrl
  includeKeyBenefitsImages
  supportEmail
  supportPhone
  websiteUrl
  privacyPolicyUrl
  termsOfServiceUrl
  icon {
    s3Key
    fileName
    fileType
    height
    width
    size
    sourceUrl
  }
  screenShots {
    type
    description
    image {
      s3Key
      fileName
      fileType
      height
      width
      size
      sourceUrl
    }
  }
  keyBenefits {
    title
    description
    image {
      s3Key
      fileName
      fileType
      height
      width
      size
      sourceUrl
    }
  }
  pricePlans {
    planId
    name
    features
  }
}
    `;
export const AppListingFragment = gql`
    fragment AppListingFragment on AppListing {
  id
  creationDate
  language
  name
  tagLine
  description
  searchTerms
  integrations
  promoVideoUrl
  includeKeyBenefitsImages
  supportEmail
  supportPhone
  websiteUrl
  privacyPolicyUrl
  termsOfServiceUrl
  offerDemoRequest
  showContactDetails
  icon {
    s3Key
    fileName
    fileType
    height
    width
    size
    sourceUrl
  }
  screenShots {
    type
    description
    image {
      s3Key
      fileName
      fileType
      height
      width
      size
      sourceUrl
    }
  }
  keyBenefits {
    title
    description
    image {
      s3Key
      fileName
      fileType
      height
      width
      size
      sourceUrl
    }
  }
  pricePlans {
    planId
    name
    features
    plan {
      id
      appId
      creationDate
      name
      type
      monthlyAmount
      yearlyAmount
      discountedYearlyPrice
    }
  }
}
    `;
export const AppFragmentCommon = gql`
    fragment AppFragmentCommon on App {
  id
  name
  creationDate
  status
  type
  apiContactEmail
  apiCredentials {
    apiKey
    secretKey
  }
  numberOfInstallations
  linkedVendor {
    id
    name
  }
  appUrl
  redirectUrlWhitelist
  chargeType
  installationCountries
  oneTimeChargeAmount
  freeTrialDays
  appReviewInstructions
  pricePlans {
    id
    creationDate
    name
    type
    discountedYearlyPrice
    monthlyAmount
    yearlyAmount
  }
  listings {
    id
    ...AppListingFragment
  }
}
    ${AppListingFragment}`;
export const PayoutSettingsCommon = gql`
    fragment PayoutSettingsCommon on PayoutSettingsType {
  abaRouting
  bankAccountNumber
  bankId
  bankName
  branchId
  currencyCode
  iban
  payableTo
  paymentTerms
  paymentType
  payoutContactEmail
  payoutContactPhoneNumber
  swift
  usResident
}
    `;
export const AppFragment = gql`
    fragment AppFragment on App {
  id
  name
  creationDate
  status
  type
  apiContactEmail
  apiCredentials {
    apiKey
    secretKey
  }
  numberOfInstallations
  linkedVendor {
    id
    name
  }
  appUrl
  redirectUrlWhitelist
  chargeType
  installationCountries
  customInstallation {
    id
  }
  testInstallation {
    id
    creationDate
  }
  oneTimeChargeAmount
  freeTrialDays
  appReviewInstructions
  pricePlans {
    id
    creationDate
    name
    type
    discountedYearlyPrice
    monthlyAmount
    yearlyAmount
    appId
  }
  webhookSubscriptions {
    id
    creationDate
    topic
    url
  }
  listings {
    id
    ...AppListingFragment
  }
}
    ${AppListingFragment}`;
export const S3UploadMutationDocument = gql`
    mutation S3UploadMutation($contentType: String) {
  s3UploadAuthorization(contentType: $contentType) {
    node {
      uploadUrl
      meta {
        id
      }
    }
  }
}
    `;
export type S3UploadMutationMutationFn = ApolloReactCommon.MutationFunction<S3UploadMutation, S3UploadMutationVariables>;

/**
 * __useS3UploadMutation__
 *
 * To run a mutation, you first call `useS3UploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useS3UploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [s3UploadMutation, { data, loading, error }] = useS3UploadMutation({
 *   variables: {
 *      contentType: // value for 'contentType'
 *   },
 * });
 */
export function useS3UploadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<S3UploadMutation, S3UploadMutationVariables>) {
        return ApolloReactHooks.useMutation<S3UploadMutation, S3UploadMutationVariables>(S3UploadMutationDocument, baseOptions);
      }
export type S3UploadMutationHookResult = ReturnType<typeof useS3UploadMutation>;
export type S3UploadMutationMutationResult = ApolloReactCommon.MutationResult<S3UploadMutation>;
export type S3UploadMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<S3UploadMutation, S3UploadMutationVariables>;
export const S3PayoutUploadMutationDocument = gql`
    mutation S3PayoutUploadMutation {
  s3UploadPayoutInvoice {
    node {
      uploadUrl
      meta {
        id
      }
    }
  }
}
    `;
export type S3PayoutUploadMutationMutationFn = ApolloReactCommon.MutationFunction<S3PayoutUploadMutation, S3PayoutUploadMutationVariables>;

/**
 * __useS3PayoutUploadMutation__
 *
 * To run a mutation, you first call `useS3PayoutUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useS3PayoutUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [s3PayoutUploadMutation, { data, loading, error }] = useS3PayoutUploadMutation({
 *   variables: {
 *   },
 * });
 */
export function useS3PayoutUploadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<S3PayoutUploadMutation, S3PayoutUploadMutationVariables>) {
        return ApolloReactHooks.useMutation<S3PayoutUploadMutation, S3PayoutUploadMutationVariables>(S3PayoutUploadMutationDocument, baseOptions);
      }
export type S3PayoutUploadMutationHookResult = ReturnType<typeof useS3PayoutUploadMutation>;
export type S3PayoutUploadMutationMutationResult = ApolloReactCommon.MutationResult<S3PayoutUploadMutation>;
export type S3PayoutUploadMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<S3PayoutUploadMutation, S3PayoutUploadMutationVariables>;
export const AppOrgUpdateDocument = gql`
    mutation AppOrgUpdate($id: ID!, $businessName: String!, $businessEmail: String, $supportEmail: String, $phoneNumber: String, $websiteUrl: String, $emergencyDeveloperEmail: String, $emergencyDeveloperPhoneNumber: String!, $termsApiAgreed: Boolean!, $termsPartnerAgreed: Boolean!) {
  appOrgUpdate(
    id: $id
    orgInfo: {businessName: $businessName, businessEmail: $businessEmail, supportEmail: $supportEmail, phoneNumber: $phoneNumber, websiteUrl: $websiteUrl, emergencyDeveloperEmail: $emergencyDeveloperEmail, emergencyDeveloperPhoneNumber: $emergencyDeveloperPhoneNumber, termsApiAgreed: $termsApiAgreed, termsPartnerAgreed: $termsPartnerAgreed}
  ) {
    node {
      id
      businessName
      businessEmail
      supportEmail
      phoneNumber
      websiteUrl
      emergencyDeveloperEmail
      emergencyDeveloperPhoneNumber
      termsApiAgreed
      termsPartnerAgreed
    }
  }
}
    `;
export type AppOrgUpdateMutationFn = ApolloReactCommon.MutationFunction<AppOrgUpdate, AppOrgUpdateVariables>;

/**
 * __useAppOrgUpdate__
 *
 * To run a mutation, you first call `useAppOrgUpdate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppOrgUpdate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appOrgUpdate, { data, loading, error }] = useAppOrgUpdate({
 *   variables: {
 *      id: // value for 'id'
 *      businessName: // value for 'businessName'
 *      businessEmail: // value for 'businessEmail'
 *      supportEmail: // value for 'supportEmail'
 *      phoneNumber: // value for 'phoneNumber'
 *      websiteUrl: // value for 'websiteUrl'
 *      emergencyDeveloperEmail: // value for 'emergencyDeveloperEmail'
 *      emergencyDeveloperPhoneNumber: // value for 'emergencyDeveloperPhoneNumber'
 *      termsApiAgreed: // value for 'termsApiAgreed'
 *      termsPartnerAgreed: // value for 'termsPartnerAgreed'
 *   },
 * });
 */
export function useAppOrgUpdate(baseOptions?: ApolloReactHooks.MutationHookOptions<AppOrgUpdate, AppOrgUpdateVariables>) {
        return ApolloReactHooks.useMutation<AppOrgUpdate, AppOrgUpdateVariables>(AppOrgUpdateDocument, baseOptions);
      }
export type AppOrgUpdateHookResult = ReturnType<typeof useAppOrgUpdate>;
export type AppOrgUpdateMutationResult = ApolloReactCommon.MutationResult<AppOrgUpdate>;
export type AppOrgUpdateMutationOptions = ApolloReactCommon.BaseMutationOptions<AppOrgUpdate, AppOrgUpdateVariables>;
export const UpdatePayoutSettingsDocument = gql`
    mutation UpdatePayoutSettings($payoutSettings: PayoutSettingsInput!) {
  payoutSettingsUpdate(payoutSettings: $payoutSettings) {
    node {
      ...PayoutSettingsCommon
    }
    successful
  }
}
    ${PayoutSettingsCommon}`;
export type UpdatePayoutSettingsMutationFn = ApolloReactCommon.MutationFunction<UpdatePayoutSettings, UpdatePayoutSettingsVariables>;

/**
 * __useUpdatePayoutSettings__
 *
 * To run a mutation, you first call `useUpdatePayoutSettings` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePayoutSettings` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePayoutSettings, { data, loading, error }] = useUpdatePayoutSettings({
 *   variables: {
 *      payoutSettings: // value for 'payoutSettings'
 *   },
 * });
 */
export function useUpdatePayoutSettings(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePayoutSettings, UpdatePayoutSettingsVariables>) {
        return ApolloReactHooks.useMutation<UpdatePayoutSettings, UpdatePayoutSettingsVariables>(UpdatePayoutSettingsDocument, baseOptions);
      }
export type UpdatePayoutSettingsHookResult = ReturnType<typeof useUpdatePayoutSettings>;
export type UpdatePayoutSettingsMutationResult = ApolloReactCommon.MutationResult<UpdatePayoutSettings>;
export type UpdatePayoutSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePayoutSettings, UpdatePayoutSettingsVariables>;
export const SubmitPayoutRequestDocument = gql`
    mutation SubmitPayoutRequest($fileInput: AppFileInputInput!) {
  submitPayoutRequest(fileInput: $fileInput) {
    successful
    node {
      id
    }
  }
}
    `;
export type SubmitPayoutRequestMutationFn = ApolloReactCommon.MutationFunction<SubmitPayoutRequest, SubmitPayoutRequestVariables>;

/**
 * __useSubmitPayoutRequest__
 *
 * To run a mutation, you first call `useSubmitPayoutRequest` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitPayoutRequest` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitPayoutRequest, { data, loading, error }] = useSubmitPayoutRequest({
 *   variables: {
 *      fileInput: // value for 'fileInput'
 *   },
 * });
 */
export function useSubmitPayoutRequest(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitPayoutRequest, SubmitPayoutRequestVariables>) {
        return ApolloReactHooks.useMutation<SubmitPayoutRequest, SubmitPayoutRequestVariables>(SubmitPayoutRequestDocument, baseOptions);
      }
export type SubmitPayoutRequestHookResult = ReturnType<typeof useSubmitPayoutRequest>;
export type SubmitPayoutRequestMutationResult = ApolloReactCommon.MutationResult<SubmitPayoutRequest>;
export type SubmitPayoutRequestMutationOptions = ApolloReactCommon.BaseMutationOptions<SubmitPayoutRequest, SubmitPayoutRequestVariables>;
export const UpdatePayoutRequestDocument = gql`
    mutation UpdatePayoutRequest($id: ID!, $fileInput: AppFileInputInput!) {
  updatePayoutRequest(id: $id, fileInput: $fileInput) {
    successful
    node {
      id
    }
  }
}
    `;
export type UpdatePayoutRequestMutationFn = ApolloReactCommon.MutationFunction<UpdatePayoutRequest, UpdatePayoutRequestVariables>;

/**
 * __useUpdatePayoutRequest__
 *
 * To run a mutation, you first call `useUpdatePayoutRequest` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePayoutRequest` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePayoutRequest, { data, loading, error }] = useUpdatePayoutRequest({
 *   variables: {
 *      id: // value for 'id'
 *      fileInput: // value for 'fileInput'
 *   },
 * });
 */
export function useUpdatePayoutRequest(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePayoutRequest, UpdatePayoutRequestVariables>) {
        return ApolloReactHooks.useMutation<UpdatePayoutRequest, UpdatePayoutRequestVariables>(UpdatePayoutRequestDocument, baseOptions);
      }
export type UpdatePayoutRequestHookResult = ReturnType<typeof useUpdatePayoutRequest>;
export type UpdatePayoutRequestMutationResult = ApolloReactCommon.MutationResult<UpdatePayoutRequest>;
export type UpdatePayoutRequestMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePayoutRequest, UpdatePayoutRequestVariables>;
export const InvoiceFileDeleteDocument = gql`
    mutation InvoiceFileDelete($fileKey: String!) {
  invoiceFileDelete(fileKey: $fileKey) {
    successful
  }
}
    `;
export type InvoiceFileDeleteMutationFn = ApolloReactCommon.MutationFunction<InvoiceFileDelete, InvoiceFileDeleteVariables>;

/**
 * __useInvoiceFileDelete__
 *
 * To run a mutation, you first call `useInvoiceFileDelete` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceFileDelete` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceFileDelete, { data, loading, error }] = useInvoiceFileDelete({
 *   variables: {
 *      fileKey: // value for 'fileKey'
 *   },
 * });
 */
export function useInvoiceFileDelete(baseOptions?: ApolloReactHooks.MutationHookOptions<InvoiceFileDelete, InvoiceFileDeleteVariables>) {
        return ApolloReactHooks.useMutation<InvoiceFileDelete, InvoiceFileDeleteVariables>(InvoiceFileDeleteDocument, baseOptions);
      }
export type InvoiceFileDeleteHookResult = ReturnType<typeof useInvoiceFileDelete>;
export type InvoiceFileDeleteMutationResult = ApolloReactCommon.MutationResult<InvoiceFileDelete>;
export type InvoiceFileDeleteMutationOptions = ApolloReactCommon.BaseMutationOptions<InvoiceFileDelete, InvoiceFileDeleteVariables>;
export const WebhookCreateDocument = gql`
    mutation WebhookCreate($appId: ID!, $topic: AppWebhookTopic!, $url: String!) {
  webhookCreate(id: $appId, webhookInfo: {topic: $topic, url: $url}) {
    node {
      id
      name
      creationDate
      status
      apiContactEmail
      apiCredentials {
        apiKey
        secretKey
      }
      numberOfInstallations
      appUrl
      redirectUrlWhitelist
      chargeType
      type
      installationCountries
      oneTimeChargeAmount
      freeTrialDays
      appReviewInstructions
      webhookSubscriptions {
        id
        creationDate
        topic
        url
      }
      pricePlans {
        id
        creationDate
        name
        type
        discountedYearlyPrice
        monthlyAmount
        yearlyAmount
      }
      listings {
        id
        creationDate
        name
        tagLine
        description
        searchTerms
        integrations
        promoVideoUrl
        includeKeyBenefitsImages
        supportEmail
        supportPhone
        websiteUrl
        privacyPolicyUrl
        termsOfServiceUrl
        icon {
          s3Key
          fileName
          fileType
          height
          width
          size
          sourceUrl
        }
        screenShots {
          type
          description
          image {
            s3Key
            fileName
            fileType
            height
            width
            size
            sourceUrl
          }
        }
        keyBenefits {
          title
          description
          image {
            s3Key
            fileName
            fileType
            height
            width
            size
            sourceUrl
          }
        }
        pricePlans {
          planId
          name
          features
        }
      }
    }
  }
}
    `;
export type WebhookCreateMutationFn = ApolloReactCommon.MutationFunction<WebhookCreate, WebhookCreateVariables>;

/**
 * __useWebhookCreate__
 *
 * To run a mutation, you first call `useWebhookCreate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebhookCreate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [webhookCreate, { data, loading, error }] = useWebhookCreate({
 *   variables: {
 *      appId: // value for 'appId'
 *      topic: // value for 'topic'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useWebhookCreate(baseOptions?: ApolloReactHooks.MutationHookOptions<WebhookCreate, WebhookCreateVariables>) {
        return ApolloReactHooks.useMutation<WebhookCreate, WebhookCreateVariables>(WebhookCreateDocument, baseOptions);
      }
export type WebhookCreateHookResult = ReturnType<typeof useWebhookCreate>;
export type WebhookCreateMutationResult = ApolloReactCommon.MutationResult<WebhookCreate>;
export type WebhookCreateMutationOptions = ApolloReactCommon.BaseMutationOptions<WebhookCreate, WebhookCreateVariables>;
export const WebhookUpdateDocument = gql`
    mutation WebhookUpdate($id: ID!, $topic: AppWebhookTopic!, $url: String!) {
  webhookUpdate(id: $id, webhookInfo: {topic: $topic, url: $url}) {
    node {
      id
      creationDate
      topic
      url
    }
  }
}
    `;
export type WebhookUpdateMutationFn = ApolloReactCommon.MutationFunction<WebhookUpdate, WebhookUpdateVariables>;

/**
 * __useWebhookUpdate__
 *
 * To run a mutation, you first call `useWebhookUpdate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebhookUpdate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [webhookUpdate, { data, loading, error }] = useWebhookUpdate({
 *   variables: {
 *      id: // value for 'id'
 *      topic: // value for 'topic'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useWebhookUpdate(baseOptions?: ApolloReactHooks.MutationHookOptions<WebhookUpdate, WebhookUpdateVariables>) {
        return ApolloReactHooks.useMutation<WebhookUpdate, WebhookUpdateVariables>(WebhookUpdateDocument, baseOptions);
      }
export type WebhookUpdateHookResult = ReturnType<typeof useWebhookUpdate>;
export type WebhookUpdateMutationResult = ApolloReactCommon.MutationResult<WebhookUpdate>;
export type WebhookUpdateMutationOptions = ApolloReactCommon.BaseMutationOptions<WebhookUpdate, WebhookUpdateVariables>;
export const WebhookDeleteDocument = gql`
    mutation WebhookDelete($id: ID!) {
  webhookDelete(id: $id) {
    node {
      id
      name
      creationDate
      status
      apiContactEmail
      apiCredentials {
        apiKey
        secretKey
      }
      numberOfInstallations
      appUrl
      redirectUrlWhitelist
      chargeType
      type
      installationCountries
      oneTimeChargeAmount
      freeTrialDays
      appReviewInstructions
      webhookSubscriptions {
        id
        creationDate
        topic
        url
      }
      pricePlans {
        id
        creationDate
        name
        type
        discountedYearlyPrice
        monthlyAmount
        yearlyAmount
      }
      listings {
        id
        creationDate
        name
        tagLine
        description
        searchTerms
        integrations
        promoVideoUrl
        includeKeyBenefitsImages
        supportEmail
        supportPhone
        websiteUrl
        privacyPolicyUrl
        termsOfServiceUrl
        icon {
          s3Key
          fileName
          fileType
          height
          width
          size
          sourceUrl
        }
        screenShots {
          type
          description
          image {
            s3Key
            fileName
            fileType
            height
            width
            size
            sourceUrl
          }
        }
        keyBenefits {
          title
          description
          image {
            s3Key
            fileName
            fileType
            height
            width
            size
            sourceUrl
          }
        }
        pricePlans {
          planId
          name
          features
        }
      }
    }
  }
}
    `;
export type WebhookDeleteMutationFn = ApolloReactCommon.MutationFunction<WebhookDelete, WebhookDeleteVariables>;

/**
 * __useWebhookDelete__
 *
 * To run a mutation, you first call `useWebhookDelete` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebhookDelete` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [webhookDelete, { data, loading, error }] = useWebhookDelete({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWebhookDelete(baseOptions?: ApolloReactHooks.MutationHookOptions<WebhookDelete, WebhookDeleteVariables>) {
        return ApolloReactHooks.useMutation<WebhookDelete, WebhookDeleteVariables>(WebhookDeleteDocument, baseOptions);
      }
export type WebhookDeleteHookResult = ReturnType<typeof useWebhookDelete>;
export type WebhookDeleteMutationResult = ApolloReactCommon.MutationResult<WebhookDelete>;
export type WebhookDeleteMutationOptions = ApolloReactCommon.BaseMutationOptions<WebhookDelete, WebhookDeleteVariables>;
export const AppCreateDocument = gql`
    mutation AppCreate($name: String!, $apiContactEmail: String!, $appUrl: String, $redirectUrlWhitelist: String, $chargeType: AppChargeType!, $type: AppVisibilityType!, $installationCountries: [String], $oneTimeChargeAmount: Float, $freeTrialDays: Int, $appReviewInstructions: String) {
  appCreate(
    appInfo: {name: $name, apiContactEmail: $apiContactEmail, appUrl: $appUrl, redirectUrlWhitelist: $redirectUrlWhitelist, chargeType: $chargeType, type: $type, installationCountries: $installationCountries, oneTimeChargeAmount: $oneTimeChargeAmount, freeTrialDays: $freeTrialDays, appReviewInstructions: $appReviewInstructions}
  ) {
    node {
      id
      name
      apiContactEmail
      apiCredentials {
        apiKey
        secretKey
      }
      appUrl
      redirectUrlWhitelist
      chargeType
      type
      installationCountries
      oneTimeChargeAmount
      freeTrialDays
      appReviewInstructions
    }
  }
}
    `;
export type AppCreateMutationFn = ApolloReactCommon.MutationFunction<AppCreate, AppCreateVariables>;

/**
 * __useAppCreate__
 *
 * To run a mutation, you first call `useAppCreate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppCreate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appCreate, { data, loading, error }] = useAppCreate({
 *   variables: {
 *      name: // value for 'name'
 *      apiContactEmail: // value for 'apiContactEmail'
 *      appUrl: // value for 'appUrl'
 *      redirectUrlWhitelist: // value for 'redirectUrlWhitelist'
 *      chargeType: // value for 'chargeType'
 *      type: // value for 'type'
 *      installationCountries: // value for 'installationCountries'
 *      oneTimeChargeAmount: // value for 'oneTimeChargeAmount'
 *      freeTrialDays: // value for 'freeTrialDays'
 *      appReviewInstructions: // value for 'appReviewInstructions'
 *   },
 * });
 */
export function useAppCreate(baseOptions?: ApolloReactHooks.MutationHookOptions<AppCreate, AppCreateVariables>) {
        return ApolloReactHooks.useMutation<AppCreate, AppCreateVariables>(AppCreateDocument, baseOptions);
      }
export type AppCreateHookResult = ReturnType<typeof useAppCreate>;
export type AppCreateMutationResult = ApolloReactCommon.MutationResult<AppCreate>;
export type AppCreateMutationOptions = ApolloReactCommon.BaseMutationOptions<AppCreate, AppCreateVariables>;
export const AppDeleteDocument = gql`
    mutation AppDelete($id: ID!) {
  appDelete(id: $id) {
    node {
      id
    }
  }
}
    `;
export type AppDeleteMutationFn = ApolloReactCommon.MutationFunction<AppDelete, AppDeleteVariables>;

/**
 * __useAppDelete__
 *
 * To run a mutation, you first call `useAppDelete` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppDelete` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appDelete, { data, loading, error }] = useAppDelete({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppDelete(baseOptions?: ApolloReactHooks.MutationHookOptions<AppDelete, AppDeleteVariables>) {
        return ApolloReactHooks.useMutation<AppDelete, AppDeleteVariables>(AppDeleteDocument, baseOptions);
      }
export type AppDeleteHookResult = ReturnType<typeof useAppDelete>;
export type AppDeleteMutationResult = ApolloReactCommon.MutationResult<AppDelete>;
export type AppDeleteMutationOptions = ApolloReactCommon.BaseMutationOptions<AppDelete, AppDeleteVariables>;
export const AppUpdateDocument = gql`
    mutation AppUpdate($id: ID!, $name: String!, $type: AppVisibilityType!, $apiContactEmail: String!, $appUrl: String, $redirectUrlWhitelist: String, $chargeType: AppChargeType!, $installationCountries: [String], $oneTimeChargeAmount: Float, $freeTrialDays: Int, $appReviewInstructions: String) {
  appUpdate(
    id: $id
    appInfo: {name: $name, type: $type, apiContactEmail: $apiContactEmail, appUrl: $appUrl, redirectUrlWhitelist: $redirectUrlWhitelist, chargeType: $chargeType, installationCountries: $installationCountries, oneTimeChargeAmount: $oneTimeChargeAmount, freeTrialDays: $freeTrialDays, appReviewInstructions: $appReviewInstructions}
  ) {
    node {
      id
      name
      creationDate
      status
      apiContactEmail
      apiCredentials {
        apiKey
        secretKey
      }
      linkedVendor {
        id
        name
      }
      numberOfInstallations
      appUrl
      redirectUrlWhitelist
      chargeType
      type
      installationCountries
      oneTimeChargeAmount
      freeTrialDays
      appReviewInstructions
      pricePlans {
        id
        creationDate
        name
        type
        discountedYearlyPrice
        monthlyAmount
        yearlyAmount
      }
      webhookSubscriptions {
        id
        creationDate
        topic
        url
      }
    }
  }
}
    `;
export type AppUpdateMutationFn = ApolloReactCommon.MutationFunction<AppUpdate, AppUpdateVariables>;

/**
 * __useAppUpdate__
 *
 * To run a mutation, you first call `useAppUpdate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppUpdate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appUpdate, { data, loading, error }] = useAppUpdate({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      type: // value for 'type'
 *      apiContactEmail: // value for 'apiContactEmail'
 *      appUrl: // value for 'appUrl'
 *      redirectUrlWhitelist: // value for 'redirectUrlWhitelist'
 *      chargeType: // value for 'chargeType'
 *      installationCountries: // value for 'installationCountries'
 *      oneTimeChargeAmount: // value for 'oneTimeChargeAmount'
 *      freeTrialDays: // value for 'freeTrialDays'
 *      appReviewInstructions: // value for 'appReviewInstructions'
 *   },
 * });
 */
export function useAppUpdate(baseOptions?: ApolloReactHooks.MutationHookOptions<AppUpdate, AppUpdateVariables>) {
        return ApolloReactHooks.useMutation<AppUpdate, AppUpdateVariables>(AppUpdateDocument, baseOptions);
      }
export type AppUpdateHookResult = ReturnType<typeof useAppUpdate>;
export type AppUpdateMutationResult = ApolloReactCommon.MutationResult<AppUpdate>;
export type AppUpdateMutationOptions = ApolloReactCommon.BaseMutationOptions<AppUpdate, AppUpdateVariables>;
export const AppCustomPublishDocument = gql`
    mutation AppCustomPublish($appId: ID!) {
  appCustomPublish(appId: $appId) {
    status
  }
}
    `;
export type AppCustomPublishMutationFn = ApolloReactCommon.MutationFunction<AppCustomPublish, AppCustomPublishVariables>;

/**
 * __useAppCustomPublish__
 *
 * To run a mutation, you first call `useAppCustomPublish` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppCustomPublish` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appCustomPublish, { data, loading, error }] = useAppCustomPublish({
 *   variables: {
 *      appId: // value for 'appId'
 *   },
 * });
 */
export function useAppCustomPublish(baseOptions?: ApolloReactHooks.MutationHookOptions<AppCustomPublish, AppCustomPublishVariables>) {
        return ApolloReactHooks.useMutation<AppCustomPublish, AppCustomPublishVariables>(AppCustomPublishDocument, baseOptions);
      }
export type AppCustomPublishHookResult = ReturnType<typeof useAppCustomPublish>;
export type AppCustomPublishMutationResult = ApolloReactCommon.MutationResult<AppCustomPublish>;
export type AppCustomPublishMutationOptions = ApolloReactCommon.BaseMutationOptions<AppCustomPublish, AppCustomPublishVariables>;
export const AppCustomLinkToVendorDocument = gql`
    mutation AppCustomLinkToVendor($appId: ID!, $vendorId: ID!) {
  appCustomLinkToVendor(appId: $appId, vendorId: $vendorId) {
    node {
      id
      name
      creationDate
      status
      apiContactEmail
      apiCredentials {
        apiKey
        secretKey
      }
      linkedVendor {
        id
        name
      }
      numberOfInstallations
      appUrl
      redirectUrlWhitelist
      chargeType
      type
      installationCountries
      oneTimeChargeAmount
      freeTrialDays
      appReviewInstructions
      pricePlans {
        id
        creationDate
        name
        type
        discountedYearlyPrice
        monthlyAmount
        yearlyAmount
      }
      listings {
        id
        creationDate
        name
        tagLine
        description
        searchTerms
        integrations
        promoVideoUrl
        includeKeyBenefitsImages
        supportEmail
        supportPhone
        websiteUrl
        privacyPolicyUrl
        termsOfServiceUrl
        icon {
          s3Key
          fileName
          fileType
          height
          width
          size
          sourceUrl
        }
        screenShots {
          type
          description
          image {
            s3Key
            fileName
            fileType
            height
            width
            size
            sourceUrl
          }
        }
        keyBenefits {
          title
          description
          image {
            s3Key
            fileName
            fileType
            height
            width
            size
            sourceUrl
          }
        }
        pricePlans {
          planId
          name
          features
        }
      }
    }
  }
}
    `;
export type AppCustomLinkToVendorMutationFn = ApolloReactCommon.MutationFunction<AppCustomLinkToVendor, AppCustomLinkToVendorVariables>;

/**
 * __useAppCustomLinkToVendor__
 *
 * To run a mutation, you first call `useAppCustomLinkToVendor` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppCustomLinkToVendor` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appCustomLinkToVendor, { data, loading, error }] = useAppCustomLinkToVendor({
 *   variables: {
 *      appId: // value for 'appId'
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useAppCustomLinkToVendor(baseOptions?: ApolloReactHooks.MutationHookOptions<AppCustomLinkToVendor, AppCustomLinkToVendorVariables>) {
        return ApolloReactHooks.useMutation<AppCustomLinkToVendor, AppCustomLinkToVendorVariables>(AppCustomLinkToVendorDocument, baseOptions);
      }
export type AppCustomLinkToVendorHookResult = ReturnType<typeof useAppCustomLinkToVendor>;
export type AppCustomLinkToVendorMutationResult = ApolloReactCommon.MutationResult<AppCustomLinkToVendor>;
export type AppCustomLinkToVendorMutationOptions = ApolloReactCommon.BaseMutationOptions<AppCustomLinkToVendor, AppCustomLinkToVendorVariables>;
export const AppTestUninstallDocument = gql`
    mutation AppTestUninstall($id: ID!) {
  appUninstallTest(id: $id) {
    node {
      id
      name
      creationDate
      status
      apiContactEmail
      apiCredentials {
        apiKey
        secretKey
      }
      numberOfInstallations
      testInstallation {
        id
        creationDate
      }
      appUrl
      redirectUrlWhitelist
      chargeType
      type
      installationCountries
      oneTimeChargeAmount
      freeTrialDays
      appReviewInstructions
      pricePlans {
        id
        creationDate
        name
        type
        discountedYearlyPrice
        monthlyAmount
        yearlyAmount
      }
      listings {
        id
        creationDate
        name
        tagLine
        description
        searchTerms
        integrations
        promoVideoUrl
        includeKeyBenefitsImages
        supportEmail
        supportPhone
        websiteUrl
        privacyPolicyUrl
        termsOfServiceUrl
        icon {
          s3Key
          fileName
          fileType
          height
          width
          size
          sourceUrl
        }
        screenShots {
          type
          description
          image {
            s3Key
            fileName
            fileType
            height
            width
            size
            sourceUrl
          }
        }
        keyBenefits {
          title
          description
          image {
            s3Key
            fileName
            fileType
            height
            width
            size
            sourceUrl
          }
        }
        pricePlans {
          planId
          name
          features
        }
      }
    }
  }
}
    `;
export type AppTestUninstallMutationFn = ApolloReactCommon.MutationFunction<AppTestUninstall, AppTestUninstallVariables>;

/**
 * __useAppTestUninstall__
 *
 * To run a mutation, you first call `useAppTestUninstall` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppTestUninstall` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appTestUninstall, { data, loading, error }] = useAppTestUninstall({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppTestUninstall(baseOptions?: ApolloReactHooks.MutationHookOptions<AppTestUninstall, AppTestUninstallVariables>) {
        return ApolloReactHooks.useMutation<AppTestUninstall, AppTestUninstallVariables>(AppTestUninstallDocument, baseOptions);
      }
export type AppTestUninstallHookResult = ReturnType<typeof useAppTestUninstall>;
export type AppTestUninstallMutationResult = ApolloReactCommon.MutationResult<AppTestUninstall>;
export type AppTestUninstallMutationOptions = ApolloReactCommon.BaseMutationOptions<AppTestUninstall, AppTestUninstallVariables>;
export const AppSubmitForReviewDocument = gql`
    mutation AppSubmitForReview($id: ID!) {
  appSubmitForReview(id: $id) {
    node {
      id
      name
      creationDate
      status
      apiContactEmail
      apiCredentials {
        apiKey
        secretKey
      }
      numberOfInstallations
      appUrl
      redirectUrlWhitelist
      chargeType
      type
      installationCountries
      oneTimeChargeAmount
      freeTrialDays
      appReviewInstructions
      pricePlans {
        id
        creationDate
        name
        type
        discountedYearlyPrice
        monthlyAmount
        yearlyAmount
      }
      listings {
        id
        creationDate
        name
        tagLine
        description
        searchTerms
        integrations
        promoVideoUrl
        includeKeyBenefitsImages
        supportEmail
        supportPhone
        websiteUrl
        privacyPolicyUrl
        termsOfServiceUrl
        icon {
          s3Key
          fileName
          fileType
          height
          width
          size
          sourceUrl
        }
        screenShots {
          type
          description
          image {
            s3Key
            fileName
            fileType
            height
            width
            size
            sourceUrl
          }
        }
        keyBenefits {
          title
          description
          image {
            s3Key
            fileName
            fileType
            height
            width
            size
            sourceUrl
          }
        }
        pricePlans {
          planId
          name
          features
        }
      }
    }
  }
}
    `;
export type AppSubmitForReviewMutationFn = ApolloReactCommon.MutationFunction<AppSubmitForReview, AppSubmitForReviewVariables>;

/**
 * __useAppSubmitForReview__
 *
 * To run a mutation, you first call `useAppSubmitForReview` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppSubmitForReview` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appSubmitForReview, { data, loading, error }] = useAppSubmitForReview({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppSubmitForReview(baseOptions?: ApolloReactHooks.MutationHookOptions<AppSubmitForReview, AppSubmitForReviewVariables>) {
        return ApolloReactHooks.useMutation<AppSubmitForReview, AppSubmitForReviewVariables>(AppSubmitForReviewDocument, baseOptions);
      }
export type AppSubmitForReviewHookResult = ReturnType<typeof useAppSubmitForReview>;
export type AppSubmitForReviewMutationResult = ApolloReactCommon.MutationResult<AppSubmitForReview>;
export type AppSubmitForReviewMutationOptions = ApolloReactCommon.BaseMutationOptions<AppSubmitForReview, AppSubmitForReviewVariables>;
export const AppListingCreateDocument = gql`
    mutation AppListingCreate($appId: ID!, $name: String!, $tagLine: String!, $description: String!, $searchTerms: [String], $integrations: [String], $promoVideoUrl: String, $includeKeyBenefitsImages: Boolean!, $supportEmail: String!, $supportPhone: String, $websiteUrl: String, $privacyPolicyUrl: String, $termsOfServiceUrl: String, $icon: AppImageUpdateInput, $screenShots: [AppScreenShotUpdateInput], $keyBenefits: [AppKeyBenefitUpdateInput], $pricePlans: [AppPricePlanDetailsUpdateInput], $showContactDetails: Boolean!, $offerDemoRequest: Boolean!) {
  appListingCreate(
    id: $appId
    listingInfo: {name: $name, tagLine: $tagLine, description: $description, searchTerms: $searchTerms, integrations: $integrations, promoVideoUrl: $promoVideoUrl, includeKeyBenefitsImages: $includeKeyBenefitsImages, supportEmail: $supportEmail, supportPhone: $supportPhone, websiteUrl: $websiteUrl, privacyPolicyUrl: $privacyPolicyUrl, termsOfServiceUrl: $termsOfServiceUrl, icon: $icon, screenShots: $screenShots, keyBenefits: $keyBenefits, pricePlans: $pricePlans, showContactDetails: $showContactDetails, offerDemoRequest: $offerDemoRequest}
  ) {
    node {
      id
      name
      creationDate
      status
      apiContactEmail
      apiCredentials {
        apiKey
        secretKey
      }
      numberOfInstallations
      appUrl
      redirectUrlWhitelist
      chargeType
      installationCountries
      oneTimeChargeAmount
      freeTrialDays
      appReviewInstructions
      pricePlans {
        id
        creationDate
        name
        type
        discountedYearlyPrice
        monthlyAmount
        yearlyAmount
      }
      listings {
        id
        creationDate
        name
        tagLine
        description
        searchTerms
        integrations
        promoVideoUrl
        includeKeyBenefitsImages
        supportEmail
        supportPhone
        websiteUrl
        privacyPolicyUrl
        termsOfServiceUrl
        showContactDetails
        offerDemoRequest
        icon {
          s3Key
          fileName
          fileType
          height
          width
          size
          sourceUrl
        }
        screenShots {
          type
          description
          image {
            s3Key
            fileName
            fileType
            height
            width
            size
            sourceUrl
          }
        }
        keyBenefits {
          title
          description
          image {
            s3Key
            fileName
            fileType
            height
            width
            size
            sourceUrl
          }
        }
        pricePlans {
          planId
          name
          features
        }
      }
    }
  }
}
    `;
export type AppListingCreateMutationFn = ApolloReactCommon.MutationFunction<AppListingCreate, AppListingCreateVariables>;

/**
 * __useAppListingCreate__
 *
 * To run a mutation, you first call `useAppListingCreate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppListingCreate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appListingCreate, { data, loading, error }] = useAppListingCreate({
 *   variables: {
 *      appId: // value for 'appId'
 *      name: // value for 'name'
 *      tagLine: // value for 'tagLine'
 *      description: // value for 'description'
 *      searchTerms: // value for 'searchTerms'
 *      integrations: // value for 'integrations'
 *      promoVideoUrl: // value for 'promoVideoUrl'
 *      includeKeyBenefitsImages: // value for 'includeKeyBenefitsImages'
 *      supportEmail: // value for 'supportEmail'
 *      supportPhone: // value for 'supportPhone'
 *      websiteUrl: // value for 'websiteUrl'
 *      privacyPolicyUrl: // value for 'privacyPolicyUrl'
 *      termsOfServiceUrl: // value for 'termsOfServiceUrl'
 *      icon: // value for 'icon'
 *      screenShots: // value for 'screenShots'
 *      keyBenefits: // value for 'keyBenefits'
 *      pricePlans: // value for 'pricePlans'
 *      showContactDetails: // value for 'showContactDetails'
 *      offerDemoRequest: // value for 'offerDemoRequest'
 *   },
 * });
 */
export function useAppListingCreate(baseOptions?: ApolloReactHooks.MutationHookOptions<AppListingCreate, AppListingCreateVariables>) {
        return ApolloReactHooks.useMutation<AppListingCreate, AppListingCreateVariables>(AppListingCreateDocument, baseOptions);
      }
export type AppListingCreateHookResult = ReturnType<typeof useAppListingCreate>;
export type AppListingCreateMutationResult = ApolloReactCommon.MutationResult<AppListingCreate>;
export type AppListingCreateMutationOptions = ApolloReactCommon.BaseMutationOptions<AppListingCreate, AppListingCreateVariables>;
export const AppListingUpdateDocument = gql`
    mutation AppListingUpdate($id: ID!, $name: String!, $tagLine: String!, $description: String!, $searchTerms: [String], $integrations: [String], $promoVideoUrl: String, $includeKeyBenefitsImages: Boolean!, $supportEmail: String!, $supportPhone: String, $websiteUrl: String, $privacyPolicyUrl: String, $termsOfServiceUrl: String, $icon: AppImageUpdateInput, $screenShots: [AppScreenShotUpdateInput], $keyBenefits: [AppKeyBenefitUpdateInput], $pricePlans: [AppPricePlanDetailsUpdateInput], $showContactDetails: Boolean!, $offerDemoRequest: Boolean!) {
  appListingUpdate(
    id: $id
    listingInfo: {name: $name, tagLine: $tagLine, description: $description, searchTerms: $searchTerms, integrations: $integrations, promoVideoUrl: $promoVideoUrl, includeKeyBenefitsImages: $includeKeyBenefitsImages, supportEmail: $supportEmail, supportPhone: $supportPhone, websiteUrl: $websiteUrl, privacyPolicyUrl: $privacyPolicyUrl, termsOfServiceUrl: $termsOfServiceUrl, icon: $icon, screenShots: $screenShots, keyBenefits: $keyBenefits, pricePlans: $pricePlans, showContactDetails: $showContactDetails, offerDemoRequest: $offerDemoRequest}
  ) {
    node {
      id
      name
      creationDate
      status
      apiContactEmail
      apiCredentials {
        apiKey
        secretKey
      }
      numberOfInstallations
      appUrl
      redirectUrlWhitelist
      chargeType
      type
      installationCountries
      oneTimeChargeAmount
      freeTrialDays
      appReviewInstructions
      webhookSubscriptions {
        id
        creationDate
        topic
        url
      }
      pricePlans {
        id
        creationDate
        name
        type
        discountedYearlyPrice
        monthlyAmount
        yearlyAmount
      }
      listings {
        id
        creationDate
        name
        tagLine
        description
        searchTerms
        integrations
        promoVideoUrl
        includeKeyBenefitsImages
        supportEmail
        supportPhone
        websiteUrl
        privacyPolicyUrl
        termsOfServiceUrl
        showContactDetails
        offerDemoRequest
        icon {
          s3Key
          fileName
          fileType
          height
          width
          size
          sourceUrl
        }
        screenShots {
          type
          description
          image {
            s3Key
            fileName
            fileType
            height
            width
            size
            sourceUrl
          }
        }
        keyBenefits {
          title
          description
          image {
            s3Key
            fileName
            fileType
            height
            width
            size
            sourceUrl
          }
        }
        pricePlans {
          planId
          name
          features
        }
      }
    }
  }
}
    `;
export type AppListingUpdateMutationFn = ApolloReactCommon.MutationFunction<AppListingUpdate, AppListingUpdateVariables>;

/**
 * __useAppListingUpdate__
 *
 * To run a mutation, you first call `useAppListingUpdate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppListingUpdate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appListingUpdate, { data, loading, error }] = useAppListingUpdate({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      tagLine: // value for 'tagLine'
 *      description: // value for 'description'
 *      searchTerms: // value for 'searchTerms'
 *      integrations: // value for 'integrations'
 *      promoVideoUrl: // value for 'promoVideoUrl'
 *      includeKeyBenefitsImages: // value for 'includeKeyBenefitsImages'
 *      supportEmail: // value for 'supportEmail'
 *      supportPhone: // value for 'supportPhone'
 *      websiteUrl: // value for 'websiteUrl'
 *      privacyPolicyUrl: // value for 'privacyPolicyUrl'
 *      termsOfServiceUrl: // value for 'termsOfServiceUrl'
 *      icon: // value for 'icon'
 *      screenShots: // value for 'screenShots'
 *      keyBenefits: // value for 'keyBenefits'
 *      pricePlans: // value for 'pricePlans'
 *      showContactDetails: // value for 'showContactDetails'
 *      offerDemoRequest: // value for 'offerDemoRequest'
 *   },
 * });
 */
export function useAppListingUpdate(baseOptions?: ApolloReactHooks.MutationHookOptions<AppListingUpdate, AppListingUpdateVariables>) {
        return ApolloReactHooks.useMutation<AppListingUpdate, AppListingUpdateVariables>(AppListingUpdateDocument, baseOptions);
      }
export type AppListingUpdateHookResult = ReturnType<typeof useAppListingUpdate>;
export type AppListingUpdateMutationResult = ApolloReactCommon.MutationResult<AppListingUpdate>;
export type AppListingUpdateMutationOptions = ApolloReactCommon.BaseMutationOptions<AppListingUpdate, AppListingUpdateVariables>;
export const AppListingDeleteDocument = gql`
    mutation AppListingDelete($id: ID!) {
  appListingDelete(id: $id) {
    node {
      id
      name
      creationDate
      status
      apiContactEmail
      apiCredentials {
        apiKey
        secretKey
      }
      numberOfInstallations
      appUrl
      redirectUrlWhitelist
      chargeType
      type
      installationCountries
      oneTimeChargeAmount
      freeTrialDays
      appReviewInstructions
      pricePlans {
        id
        creationDate
        name
        type
        discountedYearlyPrice
        monthlyAmount
        yearlyAmount
      }
      listings {
        id
        creationDate
        name
        tagLine
        description
        searchTerms
        integrations
        promoVideoUrl
        includeKeyBenefitsImages
        supportEmail
        supportPhone
        websiteUrl
        privacyPolicyUrl
        termsOfServiceUrl
        icon {
          s3Key
          fileName
          fileType
          height
          width
          size
          sourceUrl
        }
        screenShots {
          type
          description
          image {
            s3Key
            fileName
            fileType
            height
            width
            size
            sourceUrl
          }
        }
        keyBenefits {
          title
          description
          image {
            s3Key
            fileName
            fileType
            height
            width
            size
            sourceUrl
          }
        }
        pricePlans {
          planId
          name
          features
        }
      }
    }
  }
}
    `;
export type AppListingDeleteMutationFn = ApolloReactCommon.MutationFunction<AppListingDelete, AppListingDeleteVariables>;

/**
 * __useAppListingDelete__
 *
 * To run a mutation, you first call `useAppListingDelete` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppListingDelete` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appListingDelete, { data, loading, error }] = useAppListingDelete({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppListingDelete(baseOptions?: ApolloReactHooks.MutationHookOptions<AppListingDelete, AppListingDeleteVariables>) {
        return ApolloReactHooks.useMutation<AppListingDelete, AppListingDeleteVariables>(AppListingDeleteDocument, baseOptions);
      }
export type AppListingDeleteHookResult = ReturnType<typeof useAppListingDelete>;
export type AppListingDeleteMutationResult = ApolloReactCommon.MutationResult<AppListingDelete>;
export type AppListingDeleteMutationOptions = ApolloReactCommon.BaseMutationOptions<AppListingDelete, AppListingDeleteVariables>;
export const AppListingImageDeleteDocument = gql`
    mutation AppListingImageDelete($id: ID!, $imageType: AppListingImageType!, $imageKey: String!) {
  appListingImageDelete(id: $id, imageType: $imageType, imageKey: $imageKey) {
    node {
      id
      name
      creationDate
      status
      apiContactEmail
      apiCredentials {
        apiKey
        secretKey
      }
      numberOfInstallations
      appUrl
      redirectUrlWhitelist
      chargeType
      type
      installationCountries
      oneTimeChargeAmount
      freeTrialDays
      appReviewInstructions
      pricePlans {
        id
        creationDate
        name
        type
        discountedYearlyPrice
        monthlyAmount
        yearlyAmount
      }
      listings {
        id
        creationDate
        name
        tagLine
        description
        searchTerms
        integrations
        promoVideoUrl
        includeKeyBenefitsImages
        supportEmail
        supportPhone
        websiteUrl
        privacyPolicyUrl
        termsOfServiceUrl
        icon {
          s3Key
          fileName
          fileType
          height
          width
          size
          sourceUrl
        }
        screenShots {
          type
          description
          image {
            s3Key
            fileName
            fileType
            height
            width
            size
            sourceUrl
          }
        }
        keyBenefits {
          title
          description
          image {
            s3Key
            fileName
            fileType
            height
            width
            size
            sourceUrl
          }
        }
        pricePlans {
          planId
          name
          features
        }
      }
    }
  }
}
    `;
export type AppListingImageDeleteMutationFn = ApolloReactCommon.MutationFunction<AppListingImageDelete, AppListingImageDeleteVariables>;

/**
 * __useAppListingImageDelete__
 *
 * To run a mutation, you first call `useAppListingImageDelete` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppListingImageDelete` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appListingImageDelete, { data, loading, error }] = useAppListingImageDelete({
 *   variables: {
 *      id: // value for 'id'
 *      imageType: // value for 'imageType'
 *      imageKey: // value for 'imageKey'
 *   },
 * });
 */
export function useAppListingImageDelete(baseOptions?: ApolloReactHooks.MutationHookOptions<AppListingImageDelete, AppListingImageDeleteVariables>) {
        return ApolloReactHooks.useMutation<AppListingImageDelete, AppListingImageDeleteVariables>(AppListingImageDeleteDocument, baseOptions);
      }
export type AppListingImageDeleteHookResult = ReturnType<typeof useAppListingImageDelete>;
export type AppListingImageDeleteMutationResult = ApolloReactCommon.MutationResult<AppListingImageDelete>;
export type AppListingImageDeleteMutationOptions = ApolloReactCommon.BaseMutationOptions<AppListingImageDelete, AppListingImageDeleteVariables>;
export const AppPricePlanCreateDocument = gql`
    mutation AppPricePlanCreate($appId: ID!, $name: String!, $type: AppPricePlanEnumType!, $discountedYearlyPrice: Boolean!, $monthlyAmount: Float, $yearlyAmount: Float) {
  appPricePlanCreate(
    id: $appId
    planInfo: {name: $name, type: $type, discountedYearlyPrice: $discountedYearlyPrice, monthlyAmount: $monthlyAmount, yearlyAmount: $yearlyAmount}
  ) {
    node {
      id
      name
      creationDate
      status
      apiContactEmail
      apiCredentials {
        apiKey
        secretKey
      }
      numberOfInstallations
      appUrl
      redirectUrlWhitelist
      chargeType
      type
      installationCountries
      oneTimeChargeAmount
      freeTrialDays
      appReviewInstructions
      pricePlans {
        id
        creationDate
        name
        type
        discountedYearlyPrice
        monthlyAmount
        yearlyAmount
      }
    }
  }
}
    `;
export type AppPricePlanCreateMutationFn = ApolloReactCommon.MutationFunction<AppPricePlanCreate, AppPricePlanCreateVariables>;

/**
 * __useAppPricePlanCreate__
 *
 * To run a mutation, you first call `useAppPricePlanCreate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppPricePlanCreate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appPricePlanCreate, { data, loading, error }] = useAppPricePlanCreate({
 *   variables: {
 *      appId: // value for 'appId'
 *      name: // value for 'name'
 *      type: // value for 'type'
 *      discountedYearlyPrice: // value for 'discountedYearlyPrice'
 *      monthlyAmount: // value for 'monthlyAmount'
 *      yearlyAmount: // value for 'yearlyAmount'
 *   },
 * });
 */
export function useAppPricePlanCreate(baseOptions?: ApolloReactHooks.MutationHookOptions<AppPricePlanCreate, AppPricePlanCreateVariables>) {
        return ApolloReactHooks.useMutation<AppPricePlanCreate, AppPricePlanCreateVariables>(AppPricePlanCreateDocument, baseOptions);
      }
export type AppPricePlanCreateHookResult = ReturnType<typeof useAppPricePlanCreate>;
export type AppPricePlanCreateMutationResult = ApolloReactCommon.MutationResult<AppPricePlanCreate>;
export type AppPricePlanCreateMutationOptions = ApolloReactCommon.BaseMutationOptions<AppPricePlanCreate, AppPricePlanCreateVariables>;
export const AppPricePlanUpdateDocument = gql`
    mutation AppPricePlanUpdate($id: ID!, $name: String!, $type: AppPricePlanEnumType!, $discountedYearlyPrice: Boolean!, $monthlyAmount: Float, $yearlyAmount: Float) {
  appPricePlanUpdate(
    id: $id
    planInfo: {name: $name, type: $type, discountedYearlyPrice: $discountedYearlyPrice, monthlyAmount: $monthlyAmount, yearlyAmount: $yearlyAmount}
  ) {
    node {
      id
      appId
      creationDate
      name
      type
      discountedYearlyPrice
      monthlyAmount
      yearlyAmount
    }
  }
}
    `;
export type AppPricePlanUpdateMutationFn = ApolloReactCommon.MutationFunction<AppPricePlanUpdate, AppPricePlanUpdateVariables>;

/**
 * __useAppPricePlanUpdate__
 *
 * To run a mutation, you first call `useAppPricePlanUpdate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppPricePlanUpdate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appPricePlanUpdate, { data, loading, error }] = useAppPricePlanUpdate({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      type: // value for 'type'
 *      discountedYearlyPrice: // value for 'discountedYearlyPrice'
 *      monthlyAmount: // value for 'monthlyAmount'
 *      yearlyAmount: // value for 'yearlyAmount'
 *   },
 * });
 */
export function useAppPricePlanUpdate(baseOptions?: ApolloReactHooks.MutationHookOptions<AppPricePlanUpdate, AppPricePlanUpdateVariables>) {
        return ApolloReactHooks.useMutation<AppPricePlanUpdate, AppPricePlanUpdateVariables>(AppPricePlanUpdateDocument, baseOptions);
      }
export type AppPricePlanUpdateHookResult = ReturnType<typeof useAppPricePlanUpdate>;
export type AppPricePlanUpdateMutationResult = ApolloReactCommon.MutationResult<AppPricePlanUpdate>;
export type AppPricePlanUpdateMutationOptions = ApolloReactCommon.BaseMutationOptions<AppPricePlanUpdate, AppPricePlanUpdateVariables>;
export const AppPricePlanDeleteDocument = gql`
    mutation AppPricePlanDelete($id: ID!) {
  appPricePlanDelete(id: $id) {
    node {
      id
      name
      creationDate
      status
      apiContactEmail
      apiCredentials {
        apiKey
        secretKey
      }
      numberOfInstallations
      appUrl
      redirectUrlWhitelist
      chargeType
      type
      installationCountries
      oneTimeChargeAmount
      freeTrialDays
      appReviewInstructions
      pricePlans {
        id
        creationDate
        name
        type
        discountedYearlyPrice
        monthlyAmount
        yearlyAmount
      }
    }
  }
}
    `;
export type AppPricePlanDeleteMutationFn = ApolloReactCommon.MutationFunction<AppPricePlanDelete, AppPricePlanDeleteVariables>;

/**
 * __useAppPricePlanDelete__
 *
 * To run a mutation, you first call `useAppPricePlanDelete` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppPricePlanDelete` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appPricePlanDelete, { data, loading, error }] = useAppPricePlanDelete({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppPricePlanDelete(baseOptions?: ApolloReactHooks.MutationHookOptions<AppPricePlanDelete, AppPricePlanDeleteVariables>) {
        return ApolloReactHooks.useMutation<AppPricePlanDelete, AppPricePlanDeleteVariables>(AppPricePlanDeleteDocument, baseOptions);
      }
export type AppPricePlanDeleteHookResult = ReturnType<typeof useAppPricePlanDelete>;
export type AppPricePlanDeleteMutationResult = ApolloReactCommon.MutationResult<AppPricePlanDelete>;
export type AppPricePlanDeleteMutationOptions = ApolloReactCommon.BaseMutationOptions<AppPricePlanDelete, AppPricePlanDeleteVariables>;
export const AppDeveloperLogoutMutationDocument = gql`
    mutation AppDeveloperLogoutMutation {
  appAccountLogout
}
    `;
export type AppDeveloperLogoutMutationMutationFn = ApolloReactCommon.MutationFunction<AppDeveloperLogoutMutation, AppDeveloperLogoutMutationVariables>;

/**
 * __useAppDeveloperLogoutMutation__
 *
 * To run a mutation, you first call `useAppDeveloperLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppDeveloperLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appDeveloperLogoutMutation, { data, loading, error }] = useAppDeveloperLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useAppDeveloperLogoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AppDeveloperLogoutMutation, AppDeveloperLogoutMutationVariables>) {
        return ApolloReactHooks.useMutation<AppDeveloperLogoutMutation, AppDeveloperLogoutMutationVariables>(AppDeveloperLogoutMutationDocument, baseOptions);
      }
export type AppDeveloperLogoutMutationHookResult = ReturnType<typeof useAppDeveloperLogoutMutation>;
export type AppDeveloperLogoutMutationMutationResult = ApolloReactCommon.MutationResult<AppDeveloperLogoutMutation>;
export type AppDeveloperLogoutMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<AppDeveloperLogoutMutation, AppDeveloperLogoutMutationVariables>;
export const AppDeveloperLoginMutationDocument = gql`
    mutation AppDeveloperLoginMutation($email: String!, $password: String!) {
  appAccountLogin(account: {email: $email, password: $password}) {
    node {
      id
      email
      firstName
      lastName
      orgId
      orgName
      accountOwner
    }
  }
}
    `;
export type AppDeveloperLoginMutationMutationFn = ApolloReactCommon.MutationFunction<AppDeveloperLoginMutation, AppDeveloperLoginMutationVariables>;

/**
 * __useAppDeveloperLoginMutation__
 *
 * To run a mutation, you first call `useAppDeveloperLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppDeveloperLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appDeveloperLoginMutation, { data, loading, error }] = useAppDeveloperLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useAppDeveloperLoginMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AppDeveloperLoginMutation, AppDeveloperLoginMutationVariables>) {
        return ApolloReactHooks.useMutation<AppDeveloperLoginMutation, AppDeveloperLoginMutationVariables>(AppDeveloperLoginMutationDocument, baseOptions);
      }
export type AppDeveloperLoginMutationHookResult = ReturnType<typeof useAppDeveloperLoginMutation>;
export type AppDeveloperLoginMutationMutationResult = ApolloReactCommon.MutationResult<AppDeveloperLoginMutation>;
export type AppDeveloperLoginMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<AppDeveloperLoginMutation, AppDeveloperLoginMutationVariables>;
export const AppDeveloperSignupMutationDocument = gql`
    mutation AppDeveloperSignupMutation($email: String!, $password: String!, $firstName: String!, $lastName: String!, $termsApiAgreed: Boolean!, $termsPartnerAgreed: Boolean!) {
  appAccountSignup(
    account: {email: $email, password: $password, firstName: $firstName, lastName: $lastName, termsApiAgreed: $termsApiAgreed, termsPartnerAgreed: $termsPartnerAgreed}
  ) {
    node {
      id
      email
      firstName
      lastName
      orgId
      orgName
    }
  }
}
    `;
export type AppDeveloperSignupMutationMutationFn = ApolloReactCommon.MutationFunction<AppDeveloperSignupMutation, AppDeveloperSignupMutationVariables>;

/**
 * __useAppDeveloperSignupMutation__
 *
 * To run a mutation, you first call `useAppDeveloperSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppDeveloperSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appDeveloperSignupMutation, { data, loading, error }] = useAppDeveloperSignupMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      termsApiAgreed: // value for 'termsApiAgreed'
 *      termsPartnerAgreed: // value for 'termsPartnerAgreed'
 *   },
 * });
 */
export function useAppDeveloperSignupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AppDeveloperSignupMutation, AppDeveloperSignupMutationVariables>) {
        return ApolloReactHooks.useMutation<AppDeveloperSignupMutation, AppDeveloperSignupMutationVariables>(AppDeveloperSignupMutationDocument, baseOptions);
      }
export type AppDeveloperSignupMutationHookResult = ReturnType<typeof useAppDeveloperSignupMutation>;
export type AppDeveloperSignupMutationMutationResult = ApolloReactCommon.MutationResult<AppDeveloperSignupMutation>;
export type AppDeveloperSignupMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<AppDeveloperSignupMutation, AppDeveloperSignupMutationVariables>;
export const AppUserAccountUpdateDocument = gql`
    mutation AppUserAccountUpdate($id: ID!, $firstName: String!, $lastName: String!, $password: String) {
  appAccountUserUpdate(
    id: $id
    userInfo: {firstName: $firstName, lastName: $lastName, password: $password}
  ) {
    node {
      id
      email
      firstName
      lastName
      orgId
      orgName
    }
  }
}
    `;
export type AppUserAccountUpdateMutationFn = ApolloReactCommon.MutationFunction<AppUserAccountUpdate, AppUserAccountUpdateVariables>;

/**
 * __useAppUserAccountUpdate__
 *
 * To run a mutation, you first call `useAppUserAccountUpdate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppUserAccountUpdate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appUserAccountUpdate, { data, loading, error }] = useAppUserAccountUpdate({
 *   variables: {
 *      id: // value for 'id'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useAppUserAccountUpdate(baseOptions?: ApolloReactHooks.MutationHookOptions<AppUserAccountUpdate, AppUserAccountUpdateVariables>) {
        return ApolloReactHooks.useMutation<AppUserAccountUpdate, AppUserAccountUpdateVariables>(AppUserAccountUpdateDocument, baseOptions);
      }
export type AppUserAccountUpdateHookResult = ReturnType<typeof useAppUserAccountUpdate>;
export type AppUserAccountUpdateMutationResult = ApolloReactCommon.MutationResult<AppUserAccountUpdate>;
export type AppUserAccountUpdateMutationOptions = ApolloReactCommon.BaseMutationOptions<AppUserAccountUpdate, AppUserAccountUpdateVariables>;
export const AppUserAccountDeleteDocument = gql`
    mutation AppUserAccountDelete($id: ID!) {
  appAccountUserDelete(id: $id) {
    node {
      id
    }
  }
}
    `;
export type AppUserAccountDeleteMutationFn = ApolloReactCommon.MutationFunction<AppUserAccountDelete, AppUserAccountDeleteVariables>;

/**
 * __useAppUserAccountDelete__
 *
 * To run a mutation, you first call `useAppUserAccountDelete` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppUserAccountDelete` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appUserAccountDelete, { data, loading, error }] = useAppUserAccountDelete({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppUserAccountDelete(baseOptions?: ApolloReactHooks.MutationHookOptions<AppUserAccountDelete, AppUserAccountDeleteVariables>) {
        return ApolloReactHooks.useMutation<AppUserAccountDelete, AppUserAccountDeleteVariables>(AppUserAccountDeleteDocument, baseOptions);
      }
export type AppUserAccountDeleteHookResult = ReturnType<typeof useAppUserAccountDelete>;
export type AppUserAccountDeleteMutationResult = ApolloReactCommon.MutationResult<AppUserAccountDelete>;
export type AppUserAccountDeleteMutationOptions = ApolloReactCommon.BaseMutationOptions<AppUserAccountDelete, AppUserAccountDeleteVariables>;
export const AppUserAccountCreateDocument = gql`
    mutation AppUserAccountCreate($firstName: String!, $lastName: String!, $email: String!, $password: String!) {
  appAccountUserCreate(
    userInfo: {firstName: $firstName, lastName: $lastName, email: $email, password: $password}
  ) {
    node {
      id
      email
      firstName
      lastName
      orgId
      orgName
    }
  }
}
    `;
export type AppUserAccountCreateMutationFn = ApolloReactCommon.MutationFunction<AppUserAccountCreate, AppUserAccountCreateVariables>;

/**
 * __useAppUserAccountCreate__
 *
 * To run a mutation, you first call `useAppUserAccountCreate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppUserAccountCreate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appUserAccountCreate, { data, loading, error }] = useAppUserAccountCreate({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useAppUserAccountCreate(baseOptions?: ApolloReactHooks.MutationHookOptions<AppUserAccountCreate, AppUserAccountCreateVariables>) {
        return ApolloReactHooks.useMutation<AppUserAccountCreate, AppUserAccountCreateVariables>(AppUserAccountCreateDocument, baseOptions);
      }
export type AppUserAccountCreateHookResult = ReturnType<typeof useAppUserAccountCreate>;
export type AppUserAccountCreateMutationResult = ApolloReactCommon.MutationResult<AppUserAccountCreate>;
export type AppUserAccountCreateMutationOptions = ApolloReactCommon.BaseMutationOptions<AppUserAccountCreate, AppUserAccountCreateVariables>;
export const AppUserAccountChangeOrgDocument = gql`
    mutation AppUserAccountChangeOrg($id: ID!) {
  appAccountUserChangeOrg(id: $id) {
    node {
      id
      email
      firstName
      lastName
      orgId
      orgName
      adminUser
      organizationId
    }
  }
}
    `;
export type AppUserAccountChangeOrgMutationFn = ApolloReactCommon.MutationFunction<AppUserAccountChangeOrg, AppUserAccountChangeOrgVariables>;

/**
 * __useAppUserAccountChangeOrg__
 *
 * To run a mutation, you first call `useAppUserAccountChangeOrg` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppUserAccountChangeOrg` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appUserAccountChangeOrg, { data, loading, error }] = useAppUserAccountChangeOrg({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppUserAccountChangeOrg(baseOptions?: ApolloReactHooks.MutationHookOptions<AppUserAccountChangeOrg, AppUserAccountChangeOrgVariables>) {
        return ApolloReactHooks.useMutation<AppUserAccountChangeOrg, AppUserAccountChangeOrgVariables>(AppUserAccountChangeOrgDocument, baseOptions);
      }
export type AppUserAccountChangeOrgHookResult = ReturnType<typeof useAppUserAccountChangeOrg>;
export type AppUserAccountChangeOrgMutationResult = ApolloReactCommon.MutationResult<AppUserAccountChangeOrg>;
export type AppUserAccountChangeOrgMutationOptions = ApolloReactCommon.BaseMutationOptions<AppUserAccountChangeOrg, AppUserAccountChangeOrgVariables>;
export const GetAppDashboardQueryDocument = gql`
    query GetAppDashboardQuery($timestampFrom: Long!, $timestampTo: Long!, $split: AppDashboardSplitType) {
  AppDashboardQuery(
    timestampFrom: $timestampFrom
    timestampTo: $timestampTo
    split: $split
  ) {
    installations {
      label
      amount
    }
    uninstallations {
      label
      amount
    }
    installationsByCountry {
      amount
      label
    }
  }
}
    `;

/**
 * __useGetAppDashboardQuery__
 *
 * To run a query within a React component, call `useGetAppDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppDashboardQuery({
 *   variables: {
 *      timestampFrom: // value for 'timestampFrom'
 *      timestampTo: // value for 'timestampTo'
 *      split: // value for 'split'
 *   },
 * });
 */
export function useGetAppDashboardQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAppDashboardQuery, GetAppDashboardQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAppDashboardQuery, GetAppDashboardQueryVariables>(GetAppDashboardQueryDocument, baseOptions);
      }
export function useGetAppDashboardQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAppDashboardQuery, GetAppDashboardQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAppDashboardQuery, GetAppDashboardQueryVariables>(GetAppDashboardQueryDocument, baseOptions);
        }
export type GetAppDashboardQueryHookResult = ReturnType<typeof useGetAppDashboardQuery>;
export type GetAppDashboardQueryLazyQueryHookResult = ReturnType<typeof useGetAppDashboardQueryLazyQuery>;
export type GetAppDashboardQueryQueryResult = ApolloReactCommon.QueryResult<GetAppDashboardQuery, GetAppDashboardQueryVariables>;
export function refetchGetAppDashboardQuery(variables?: GetAppDashboardQueryVariables) {
      return { query: GetAppDashboardQueryDocument, variables: variables }
    }
export const AppOrgListQueryDocument = gql`
    query AppOrgListQuery {
  GetOrganizations {
    id
    businessName
    supportEmail
    organizationId
  }
}
    `;

/**
 * __useAppOrgListQuery__
 *
 * To run a query within a React component, call `useAppOrgListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppOrgListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppOrgListQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppOrgListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AppOrgListQuery, AppOrgListQueryVariables>) {
        return ApolloReactHooks.useQuery<AppOrgListQuery, AppOrgListQueryVariables>(AppOrgListQueryDocument, baseOptions);
      }
export function useAppOrgListQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AppOrgListQuery, AppOrgListQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AppOrgListQuery, AppOrgListQueryVariables>(AppOrgListQueryDocument, baseOptions);
        }
export type AppOrgListQueryHookResult = ReturnType<typeof useAppOrgListQuery>;
export type AppOrgListQueryLazyQueryHookResult = ReturnType<typeof useAppOrgListQueryLazyQuery>;
export type AppOrgListQueryQueryResult = ApolloReactCommon.QueryResult<AppOrgListQuery, AppOrgListQueryVariables>;
export function refetchAppOrgListQuery(variables?: AppOrgListQueryVariables) {
      return { query: AppOrgListQueryDocument, variables: variables }
    }
export const AppOrgQueryDocument = gql`
    query AppOrgQuery($id: ID!) {
  appOrg(id: $id) {
    id
    businessName
    businessEmail
    supportEmail
    phoneNumber
    websiteUrl
    emergencyDeveloperEmail
    emergencyDeveloperPhoneNumber
    termsApiAgreed
    termsPartnerAgreed
  }
}
    `;

/**
 * __useAppOrgQuery__
 *
 * To run a query within a React component, call `useAppOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppOrgQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppOrgQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AppOrgQuery, AppOrgQueryVariables>) {
        return ApolloReactHooks.useQuery<AppOrgQuery, AppOrgQueryVariables>(AppOrgQueryDocument, baseOptions);
      }
export function useAppOrgQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AppOrgQuery, AppOrgQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AppOrgQuery, AppOrgQueryVariables>(AppOrgQueryDocument, baseOptions);
        }
export type AppOrgQueryHookResult = ReturnType<typeof useAppOrgQuery>;
export type AppOrgQueryLazyQueryHookResult = ReturnType<typeof useAppOrgQueryLazyQuery>;
export type AppOrgQueryQueryResult = ApolloReactCommon.QueryResult<AppOrgQuery, AppOrgQueryVariables>;
export function refetchAppOrgQuery(variables?: AppOrgQueryVariables) {
      return { query: AppOrgQueryDocument, variables: variables }
    }
export const AppOrgStatusQueryDocument = gql`
    query AppOrgStatusQuery {
  appOrgStatus {
    hasRejectedPayout
    hasUnclaimedPayout
    periodFrom
    periodTo
    hasValidPayoutSettings
    hasValidTaxForm
    payoutSettingsPreview
    amount
    displayAmount
  }
}
    `;

/**
 * __useAppOrgStatusQuery__
 *
 * To run a query within a React component, call `useAppOrgStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppOrgStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppOrgStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppOrgStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AppOrgStatusQuery, AppOrgStatusQueryVariables>) {
        return ApolloReactHooks.useQuery<AppOrgStatusQuery, AppOrgStatusQueryVariables>(AppOrgStatusQueryDocument, baseOptions);
      }
export function useAppOrgStatusQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AppOrgStatusQuery, AppOrgStatusQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AppOrgStatusQuery, AppOrgStatusQueryVariables>(AppOrgStatusQueryDocument, baseOptions);
        }
export type AppOrgStatusQueryHookResult = ReturnType<typeof useAppOrgStatusQuery>;
export type AppOrgStatusQueryLazyQueryHookResult = ReturnType<typeof useAppOrgStatusQueryLazyQuery>;
export type AppOrgStatusQueryQueryResult = ApolloReactCommon.QueryResult<AppOrgStatusQuery, AppOrgStatusQueryVariables>;
export function refetchAppOrgStatusQuery(variables?: AppOrgStatusQueryVariables) {
      return { query: AppOrgStatusQueryDocument, variables: variables }
    }
export const GetPayoutSettingsDocument = gql`
    query GetPayoutSettings {
  getPayoutSettings {
    ...PayoutSettingsCommon
  }
}
    ${PayoutSettingsCommon}`;

/**
 * __useGetPayoutSettings__
 *
 * To run a query within a React component, call `useGetPayoutSettings` and pass it any options that fit your needs.
 * When your component renders, `useGetPayoutSettings` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayoutSettings({
 *   variables: {
 *   },
 * });
 */
export function useGetPayoutSettings(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPayoutSettings, GetPayoutSettingsVariables>) {
        return ApolloReactHooks.useQuery<GetPayoutSettings, GetPayoutSettingsVariables>(GetPayoutSettingsDocument, baseOptions);
      }
export function useGetPayoutSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPayoutSettings, GetPayoutSettingsVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPayoutSettings, GetPayoutSettingsVariables>(GetPayoutSettingsDocument, baseOptions);
        }
export type GetPayoutSettingsHookResult = ReturnType<typeof useGetPayoutSettings>;
export type GetPayoutSettingsLazyQueryHookResult = ReturnType<typeof useGetPayoutSettingsLazyQuery>;
export type GetPayoutSettingsQueryResult = ApolloReactCommon.QueryResult<GetPayoutSettings, GetPayoutSettingsVariables>;
export function refetchGetPayoutSettings(variables?: GetPayoutSettingsVariables) {
      return { query: GetPayoutSettingsDocument, variables: variables }
    }
export const GetDeveloperPayoutsDocument = gql`
    query GetDeveloperPayouts($after: String, $first: Int!) {
  getPayouts(first: $first, after: $after) {
    edges {
      node {
        id
        amount
        creationDate
        invoiceDateFrom
        invoiceDateTo
        pdfInvoiceUrl
        status
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetDeveloperPayouts__
 *
 * To run a query within a React component, call `useGetDeveloperPayouts` and pass it any options that fit your needs.
 * When your component renders, `useGetDeveloperPayouts` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeveloperPayouts({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetDeveloperPayouts(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDeveloperPayouts, GetDeveloperPayoutsVariables>) {
        return ApolloReactHooks.useQuery<GetDeveloperPayouts, GetDeveloperPayoutsVariables>(GetDeveloperPayoutsDocument, baseOptions);
      }
export function useGetDeveloperPayoutsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDeveloperPayouts, GetDeveloperPayoutsVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDeveloperPayouts, GetDeveloperPayoutsVariables>(GetDeveloperPayoutsDocument, baseOptions);
        }
export type GetDeveloperPayoutsHookResult = ReturnType<typeof useGetDeveloperPayouts>;
export type GetDeveloperPayoutsLazyQueryHookResult = ReturnType<typeof useGetDeveloperPayoutsLazyQuery>;
export type GetDeveloperPayoutsQueryResult = ApolloReactCommon.QueryResult<GetDeveloperPayouts, GetDeveloperPayoutsVariables>;
export function refetchGetDeveloperPayouts(variables?: GetDeveloperPayoutsVariables) {
      return { query: GetDeveloperPayoutsDocument, variables: variables }
    }
export const GetDeveloperPayoutDocument = gql`
    query GetDeveloperPayout($id: ID!) {
  getPayoutDetails(id: $id) {
    status
    reason
    payoutInvoice {
      fileName
      fileType
      s3Key
      id
      size
    }
    pdfInvoiceUrl
  }
}
    `;

/**
 * __useGetDeveloperPayout__
 *
 * To run a query within a React component, call `useGetDeveloperPayout` and pass it any options that fit your needs.
 * When your component renders, `useGetDeveloperPayout` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeveloperPayout({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDeveloperPayout(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDeveloperPayout, GetDeveloperPayoutVariables>) {
        return ApolloReactHooks.useQuery<GetDeveloperPayout, GetDeveloperPayoutVariables>(GetDeveloperPayoutDocument, baseOptions);
      }
export function useGetDeveloperPayoutLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDeveloperPayout, GetDeveloperPayoutVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDeveloperPayout, GetDeveloperPayoutVariables>(GetDeveloperPayoutDocument, baseOptions);
        }
export type GetDeveloperPayoutHookResult = ReturnType<typeof useGetDeveloperPayout>;
export type GetDeveloperPayoutLazyQueryHookResult = ReturnType<typeof useGetDeveloperPayoutLazyQuery>;
export type GetDeveloperPayoutQueryResult = ApolloReactCommon.QueryResult<GetDeveloperPayout, GetDeveloperPayoutVariables>;
export function refetchGetDeveloperPayout(variables?: GetDeveloperPayoutVariables) {
      return { query: GetDeveloperPayoutDocument, variables: variables }
    }
export const CurrenciesDocument = gql`
    query Currencies {
  GetCurrencies {
    label
    value
  }
}
    `;

/**
 * __useCurrencies__
 *
 * To run a query within a React component, call `useCurrencies` and pass it any options that fit your needs.
 * When your component renders, `useCurrencies` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrencies({
 *   variables: {
 *   },
 * });
 */
export function useCurrencies(baseOptions?: ApolloReactHooks.QueryHookOptions<Currencies, CurrenciesVariables>) {
        return ApolloReactHooks.useQuery<Currencies, CurrenciesVariables>(CurrenciesDocument, baseOptions);
      }
export function useCurrenciesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Currencies, CurrenciesVariables>) {
          return ApolloReactHooks.useLazyQuery<Currencies, CurrenciesVariables>(CurrenciesDocument, baseOptions);
        }
export type CurrenciesHookResult = ReturnType<typeof useCurrencies>;
export type CurrenciesLazyQueryHookResult = ReturnType<typeof useCurrenciesLazyQuery>;
export type CurrenciesQueryResult = ApolloReactCommon.QueryResult<Currencies, CurrenciesVariables>;
export function refetchCurrencies(variables?: CurrenciesVariables) {
      return { query: CurrenciesDocument, variables: variables }
    }
export const AppListQueryDocument = gql`
    query AppListQuery($after: String, $first: Int!) {
  apps(first: $first, after: $after) {
    totalCount
    pageInfo {
      endCursor
      startCursor
      hasPreviousPage
      hasNextPage
    }
    edges {
      cursor
      node {
        id
        name
        creationDate
        status
        type
        numberOfInstallations
        linkedVendor {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useAppListQuery__
 *
 * To run a query within a React component, call `useAppListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppListQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useAppListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AppListQuery, AppListQueryVariables>) {
        return ApolloReactHooks.useQuery<AppListQuery, AppListQueryVariables>(AppListQueryDocument, baseOptions);
      }
export function useAppListQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AppListQuery, AppListQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AppListQuery, AppListQueryVariables>(AppListQueryDocument, baseOptions);
        }
export type AppListQueryHookResult = ReturnType<typeof useAppListQuery>;
export type AppListQueryLazyQueryHookResult = ReturnType<typeof useAppListQueryLazyQuery>;
export type AppListQueryQueryResult = ApolloReactCommon.QueryResult<AppListQuery, AppListQueryVariables>;
export function refetchAppListQuery(variables?: AppListQueryVariables) {
      return { query: AppListQueryDocument, variables: variables }
    }
export const AppQueryDocument = gql`
    query AppQuery($id: ID!) {
  app(id: $id) {
    id
    ...AppFragment
  }
}
    ${AppFragment}`;

/**
 * __useAppQuery__
 *
 * To run a query within a React component, call `useAppQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AppQuery, AppQueryVariables>) {
        return ApolloReactHooks.useQuery<AppQuery, AppQueryVariables>(AppQueryDocument, baseOptions);
      }
export function useAppQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AppQuery, AppQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AppQuery, AppQueryVariables>(AppQueryDocument, baseOptions);
        }
export type AppQueryHookResult = ReturnType<typeof useAppQuery>;
export type AppQueryLazyQueryHookResult = ReturnType<typeof useAppQueryLazyQuery>;
export type AppQueryQueryResult = ApolloReactCommon.QueryResult<AppQuery, AppQueryVariables>;
export function refetchAppQuery(variables?: AppQueryVariables) {
      return { query: AppQueryDocument, variables: variables }
    }
export const AppValidationReportQueryDocument = gql`
    query AppValidationReportQuery($id: ID!) {
  appValidationReport(id: $id) {
    valid
    testInstallationSuccessful
    items {
      valid
      type
      message
    }
    listingsReports {
      listingId
      language
      valid
      items {
        valid
        type
        message
      }
    }
  }
}
    `;

/**
 * __useAppValidationReportQuery__
 *
 * To run a query within a React component, call `useAppValidationReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppValidationReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppValidationReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppValidationReportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AppValidationReportQuery, AppValidationReportQueryVariables>) {
        return ApolloReactHooks.useQuery<AppValidationReportQuery, AppValidationReportQueryVariables>(AppValidationReportQueryDocument, baseOptions);
      }
export function useAppValidationReportQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AppValidationReportQuery, AppValidationReportQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AppValidationReportQuery, AppValidationReportQueryVariables>(AppValidationReportQueryDocument, baseOptions);
        }
export type AppValidationReportQueryHookResult = ReturnType<typeof useAppValidationReportQuery>;
export type AppValidationReportQueryLazyQueryHookResult = ReturnType<typeof useAppValidationReportQueryLazyQuery>;
export type AppValidationReportQueryQueryResult = ApolloReactCommon.QueryResult<AppValidationReportQuery, AppValidationReportQueryVariables>;
export function refetchAppValidationReportQuery(variables?: AppValidationReportQueryVariables) {
      return { query: AppValidationReportQueryDocument, variables: variables }
    }
export const AppUserAccountQueryDocument = gql`
    query AppUserAccountQuery($id: ID!) {
  appAccountUser(id: $id) {
    id
    email
    firstName
    lastName
    orgId
    orgName
    organizationId
    adminUser
  }
}
    `;

/**
 * __useAppUserAccountQuery__
 *
 * To run a query within a React component, call `useAppUserAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppUserAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppUserAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppUserAccountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AppUserAccountQuery, AppUserAccountQueryVariables>) {
        return ApolloReactHooks.useQuery<AppUserAccountQuery, AppUserAccountQueryVariables>(AppUserAccountQueryDocument, baseOptions);
      }
export function useAppUserAccountQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AppUserAccountQuery, AppUserAccountQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AppUserAccountQuery, AppUserAccountQueryVariables>(AppUserAccountQueryDocument, baseOptions);
        }
export type AppUserAccountQueryHookResult = ReturnType<typeof useAppUserAccountQuery>;
export type AppUserAccountQueryLazyQueryHookResult = ReturnType<typeof useAppUserAccountQueryLazyQuery>;
export type AppUserAccountQueryQueryResult = ApolloReactCommon.QueryResult<AppUserAccountQuery, AppUserAccountQueryVariables>;
export function refetchAppUserAccountQuery(variables?: AppUserAccountQueryVariables) {
      return { query: AppUserAccountQueryDocument, variables: variables }
    }
export const UserListQueryDocument = gql`
    query UserListQuery($filter: AppUserAccountFilterInput, $sorting: AppUserAccountSortInput, $after: String, $first: Int!) {
  appAccountUserList(
    filter: $filter
    sorting: $sorting
    first: $first
    after: $after
  ) {
    totalCount
    edges {
      cursor
      node {
        id
        email
        firstName
        lastName
        accountOwner
      }
    }
  }
}
    `;

/**
 * __useUserListQuery__
 *
 * To run a query within a React component, call `useUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sorting: // value for 'sorting'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useUserListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserListQuery, UserListQueryVariables>) {
        return ApolloReactHooks.useQuery<UserListQuery, UserListQueryVariables>(UserListQueryDocument, baseOptions);
      }
export function useUserListQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserListQuery, UserListQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<UserListQuery, UserListQueryVariables>(UserListQueryDocument, baseOptions);
        }
export type UserListQueryHookResult = ReturnType<typeof useUserListQuery>;
export type UserListQueryLazyQueryHookResult = ReturnType<typeof useUserListQueryLazyQuery>;
export type UserListQueryQueryResult = ApolloReactCommon.QueryResult<UserListQuery, UserListQueryVariables>;
export function refetchUserListQuery(variables?: UserListQueryVariables) {
      return { query: UserListQueryDocument, variables: variables }
    }
export const PublicAppListingsQueryDocument = gql`
    query PublicAppListingsQuery($filter: AppListingFilterInput, $sorting: AppListingSortInput, $after: String, $first: Int!) {
  publicAppListings(
    filter: $filter
    sorting: $sorting
    first: $first
    after: $after
  ) {
    totalCount
    edges {
      cursor
      node {
        id
        appId
        name
        tagLine
        chargeType
        freeTrialDays
        oneTimeChargeAmount
        pricePlans {
          planId
          name
          plan {
            oneTimeAmount
            monthlyAmount
            yearlyAmount
            bookingFeePercentage
          }
        }
        icon {
          sourceUrl
        }
      }
    }
  }
}
    `;

/**
 * __usePublicAppListingsQuery__
 *
 * To run a query within a React component, call `usePublicAppListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicAppListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicAppListingsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sorting: // value for 'sorting'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function usePublicAppListingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PublicAppListingsQuery, PublicAppListingsQueryVariables>) {
        return ApolloReactHooks.useQuery<PublicAppListingsQuery, PublicAppListingsQueryVariables>(PublicAppListingsQueryDocument, baseOptions);
      }
export function usePublicAppListingsQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PublicAppListingsQuery, PublicAppListingsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<PublicAppListingsQuery, PublicAppListingsQueryVariables>(PublicAppListingsQueryDocument, baseOptions);
        }
export type PublicAppListingsQueryHookResult = ReturnType<typeof usePublicAppListingsQuery>;
export type PublicAppListingsQueryLazyQueryHookResult = ReturnType<typeof usePublicAppListingsQueryLazyQuery>;
export type PublicAppListingsQueryQueryResult = ApolloReactCommon.QueryResult<PublicAppListingsQuery, PublicAppListingsQueryVariables>;
export function refetchPublicAppListingsQuery(variables?: PublicAppListingsQueryVariables) {
      return { query: PublicAppListingsQueryDocument, variables: variables }
    }
export const PublicAppListingByIdQueryDocument = gql`
    query PublicAppListingByIdQuery($id: ID!) {
  publicAppListing(id: $id) {
    id
    appId
    name
    tagLine
    organization {
      id
      businessName
      businessEmail
      websiteUrl
      phoneNumber
      supportEmail
    }
    description
    promoVideoUrl
    supportEmail
    supportPhone
    websiteUrl
    privacyPolicyUrl
    termsOfServiceUrl
    includeKeyBenefitsImages
    icon {
      s3Key
      fileName
      fileType
      height
      width
      size
      sourceUrl
      temp
    }
    screenShots {
      type
      description
      image {
        s3Key
        fileName
        fileType
        height
        width
        size
        sourceUrl
      }
    }
    keyBenefits {
      title
      description
      image {
        s3Key
        fileName
        fileType
        height
        width
        size
        sourceUrl
      }
    }
    appUrl
    chargeType
    freeTrialDays
    oneTimeChargeAmount
    pricePlans {
      planId
      name
      features
      plan {
        id
        type
        monthlyAmount
        yearlyAmount
        discountedYearlyPrice
        bookingFeePercentage
      }
    }
  }
}
    `;

/**
 * __usePublicAppListingByIdQuery__
 *
 * To run a query within a React component, call `usePublicAppListingByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicAppListingByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicAppListingByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublicAppListingByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PublicAppListingByIdQuery, PublicAppListingByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<PublicAppListingByIdQuery, PublicAppListingByIdQueryVariables>(PublicAppListingByIdQueryDocument, baseOptions);
      }
export function usePublicAppListingByIdQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PublicAppListingByIdQuery, PublicAppListingByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<PublicAppListingByIdQuery, PublicAppListingByIdQueryVariables>(PublicAppListingByIdQueryDocument, baseOptions);
        }
export type PublicAppListingByIdQueryHookResult = ReturnType<typeof usePublicAppListingByIdQuery>;
export type PublicAppListingByIdQueryLazyQueryHookResult = ReturnType<typeof usePublicAppListingByIdQueryLazyQuery>;
export type PublicAppListingByIdQueryQueryResult = ApolloReactCommon.QueryResult<PublicAppListingByIdQuery, PublicAppListingByIdQueryVariables>;
export function refetchPublicAppListingByIdQuery(variables?: PublicAppListingByIdQueryVariables) {
      return { query: PublicAppListingByIdQueryDocument, variables: variables }
    }
export const AppInstallationsQueryDocument = gql`
    query AppInstallationsQuery($appId: ID!, $after: String, $first: Int!) {
  installations(id: $appId, first: $first, after: $after) {
    totalCount
    pageInfo {
      endCursor
      startCursor
      hasPreviousPage
      hasNextPage
    }
    edges {
      cursor
      node {
        id
        creationDate
        vendor {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useAppInstallationsQuery__
 *
 * To run a query within a React component, call `useAppInstallationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppInstallationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppInstallationsQuery({
 *   variables: {
 *      appId: // value for 'appId'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useAppInstallationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AppInstallationsQuery, AppInstallationsQueryVariables>) {
        return ApolloReactHooks.useQuery<AppInstallationsQuery, AppInstallationsQueryVariables>(AppInstallationsQueryDocument, baseOptions);
      }
export function useAppInstallationsQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AppInstallationsQuery, AppInstallationsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AppInstallationsQuery, AppInstallationsQueryVariables>(AppInstallationsQueryDocument, baseOptions);
        }
export type AppInstallationsQueryHookResult = ReturnType<typeof useAppInstallationsQuery>;
export type AppInstallationsQueryLazyQueryHookResult = ReturnType<typeof useAppInstallationsQueryLazyQuery>;
export type AppInstallationsQueryQueryResult = ApolloReactCommon.QueryResult<AppInstallationsQuery, AppInstallationsQueryVariables>;
export function refetchAppInstallationsQuery(variables?: AppInstallationsQueryVariables) {
      return { query: AppInstallationsQueryDocument, variables: variables }
    }
export const AppInstallationQueryDocument = gql`
    query AppInstallationQuery($id: ID!) {
  installation(id: $id) {
    id
    creationDate
    vendor {
      id
      name
    }
    oldRestApiCredentials {
      accessKey
      secretKey
    }
  }
}
    `;

/**
 * __useAppInstallationQuery__
 *
 * To run a query within a React component, call `useAppInstallationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppInstallationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppInstallationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppInstallationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AppInstallationQuery, AppInstallationQueryVariables>) {
        return ApolloReactHooks.useQuery<AppInstallationQuery, AppInstallationQueryVariables>(AppInstallationQueryDocument, baseOptions);
      }
export function useAppInstallationQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AppInstallationQuery, AppInstallationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AppInstallationQuery, AppInstallationQueryVariables>(AppInstallationQueryDocument, baseOptions);
        }
export type AppInstallationQueryHookResult = ReturnType<typeof useAppInstallationQuery>;
export type AppInstallationQueryLazyQueryHookResult = ReturnType<typeof useAppInstallationQueryLazyQuery>;
export type AppInstallationQueryQueryResult = ApolloReactCommon.QueryResult<AppInstallationQuery, AppInstallationQueryVariables>;
export function refetchAppInstallationQuery(variables?: AppInstallationQueryVariables) {
      return { query: AppInstallationQueryDocument, variables: variables }
    }
export const AppVendorSearchQueryDocument = gql`
    query AppVendorSearchQuery($query: String, $after: String, $first: Int!) {
  appVendorSearch(query: $query, first: $first, after: $after) {
    totalCount
    edges {
      cursor
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useAppVendorSearchQuery__
 *
 * To run a query within a React component, call `useAppVendorSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppVendorSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppVendorSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useAppVendorSearchQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AppVendorSearchQuery, AppVendorSearchQueryVariables>) {
        return ApolloReactHooks.useQuery<AppVendorSearchQuery, AppVendorSearchQueryVariables>(AppVendorSearchQueryDocument, baseOptions);
      }
export function useAppVendorSearchQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AppVendorSearchQuery, AppVendorSearchQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AppVendorSearchQuery, AppVendorSearchQueryVariables>(AppVendorSearchQueryDocument, baseOptions);
        }
export type AppVendorSearchQueryHookResult = ReturnType<typeof useAppVendorSearchQuery>;
export type AppVendorSearchQueryLazyQueryHookResult = ReturnType<typeof useAppVendorSearchQueryLazyQuery>;
export type AppVendorSearchQueryQueryResult = ApolloReactCommon.QueryResult<AppVendorSearchQuery, AppVendorSearchQueryVariables>;
export function refetchAppVendorSearchQuery(variables?: AppVendorSearchQueryVariables) {
      return { query: AppVendorSearchQueryDocument, variables: variables }
    }